/* Language pack: es */
export const translationsEs = {
	resumeRecording: "Reanudar",
	chatCallMissed: "Perdida",
	chatCallDeclined: "Rechazada",
	chatAudioConference: "Conferencia de audio",
	chatVideoConference: "Videoconferencia",

	IDCardImages: "Imágenes de tarjeta de identificación",
	IT: "TI",
	Status: "Estado",
	abbreviation: "Abreviatura",
	aboutUsItems: "Elementos Sobre nosotros",
	absent: "Ausente",
	accept: "Aceptar",
	actSendingDate: "Fecha de envío del acto",
	actionTimestamp: "Marca de tiempo de la acción",
	actionType: "Tipo de acción",
	actions: "Acciones",
	activateStep7_8_9: "Asignación al departamento de líneas de transmisión de energía ( 7, 8, 9 )",
	activateStep8: "Asignación al departamento geodésico ( 8 )",
	activatedProjects: "Proyectos activados",
	active: "Activo",
	activeCarts: "Carritos activos",
	activeClients: "Clientes activos",
	activeCustomers: "Clientes activos",
	activeProjectSteps: "Pasos activos del proyecto",
	activePromos: "Promociones activas",
	activeSales: "Ventas activas",
	activeSalesEvents: "Eventos de venta activos",
	activeServices: "servicios activos",
	activeSteps: "Pasos activos",
	activeStreams: "Transmisiones activas",
	activeTasks: "Tareas activas",
	activeTime: "Tiempo activo",
	activity: "Actividad",
	actualHours: "Horas reales",
	adInterval: "Intervalo de anuncios",
	adIntervalOverride: "Reglas de planificación",
	adIntervalOverrideDesc: "Reglas de planificación",
	adIntervalOverrideValue: "Reglas de planificación",
	adPlaylist: "Lista de reproducción de anuncios",
	adPlaylists: "Listas de reproducción publicitarias",
	adTracks: "Pistas publicitarias",
	add: "Añadir",
	addAttendance: "Agregar asistencia",
	addFeature: "Añadir función",
	addFeatureLine: "Añadir línea de función",
	addFiles: "Agregar archivos",
	addMoreFiles: "Agregar más archivos",
	addNew: "Agregar nuevo",
	addPriceLine: "Añadir línea de precio",
	addRule: "Añadir regla",
	addToList: "Agregar a la lista",
	addVacationInterval: "Agregar intervalo de vacaciones",
	added: "Añadido",
	additionalDetails: "Detalles adicionales",
	address: "Dirección",
	addressData: "Datos de dirección",
	advanceDeductions: "Deducciones de anticipo",
	advertisement: "Publicidad",
	age: "Edad",
	ageGroups: "Grupos de edad",
	ago: "hace",
	agreedProjects: "Proyectos acordados",
	agreementAquipment: "Acuerdo sobre equipos",
	aiConversations: "Conversaciones",
	album: "Álbum",
	allArtists: "todos los artistas",
	allAudioTracks: "todas las pistas de audio",
	allContentItems: "todos los elementos de contenido",
	allFilesDeleted: "Todos los archivos han sido eliminados permanentemente",
	allFilesWillBeDeleted: "Todos los archivos se eliminarán de forma permanente",
	allPlaylists: "todas las listas de reproducción",
	allRegisteredContacts: "todos los clientes registrados",
	allTickets: "Todos los tickets",
	amount: "Cantidad",
	analytics: "Analítica",
	answer: "Respuesta",
	apartment: "Apartamento",
	apply: "Aplicar",
	appsMenu: "Menú de aplicaciones",
	approved: "Aprobado",
	approvedInterval: "Intervalo aprobado",
	archive: "Archivo",
	archived: "Archivado",
	areYouSure: "¿Estás seguro?",
	areYouSureToDelete: "¿Estás seguro de que deseas eliminar esto?",
	artist: "Artista",
	artistObject: "Objeto artístico",
	assignedTo: "Asignado a",
	assignedToUser: "Asignado a",
	assignmentToTheConstructionDepartment: "Asignación al departamento de construcción",
	attach: "Adjuntar",
	attachFile: "Adjuntar archivo",
	attachments: "Archivos adjuntos",
	attendance: "Asistencia",
	attendanceFlag: "Estado de asistencia",
	attendanceRequiringAttention: "Empleados que requieren atención",
	attendanceNoAttentionItems: "Ningún empleado requiere atención",
	attendanceMissingCheckIn: "Falta entrada",
	attendanceMissingCheckOut: "Falta salida",
	attendanceEarlyLeave: "Salida anticipada",
	attendanceEarlyMissings: "Salidas anticipadas",
	attendanceEarlyMissingHours: "Horas de salida anticipada",
	attendanceLateHours: "Horas de retraso",
	attendanceShowWorkedHours: "Mostrar horas trabajadas",
	attendanceUnapprovedAbsence: "Ausencia no aprobada",
	attendanceDeptAttendance: "Asistencia por departamento",
	attendanceDeviceHealth: "Estado de dispositivos y sincronización en vivo",
	attendanceLastSync: "Última sincronización",
	attendanceLiveFeed: "Feed de asistencia en vivo",
	attendanceNoRecentPunches: "Sin fichajes recientes",
	attendanceManualEntryTag: "Manual",
	attendanceUnmappedPunch: "Sin asignar",
	attendancePendingItems: "pendiente",
	flexCardTotal: "Tarjetas Flex",
	attendanceCards: "Tarjetas de asistencia",
	flexCardTotalSubtitle: "IDs Flex asignados o ignorados",
	flexCardsAttached: "Vinculado",
	flexCardsAttachedSubtitle: "IDs únicos vinculados a usuarios",
	flexCardsIgnored: "Ignorado",
	flexCardsIgnoredSubtitle: "Ignorado en la configuración de RR. HH.",
	flexCardsDuplicateAttached: "Vinculado duplicado",
	flexCardIds: "IDs de tarjeta",
	noDuplicateFlexCards: "Sin duplicados",
	attendanceTrendPctOfEmployeesPresent: "% de empleados presentes",
	yesterday: "Ayer",
	attendanceFilterThisWeek: "Esta semana",
	attendanceFilterThisMonth: "Este mes",
	attendanceFilterCustom: "Personalizado",
	attendanceSelectRange: "Seleccionar rango",
	attendanceCustomRangeCapped: "El rango personalizado está limitado a 90 días",
	attendanceLiveBadge: "LIVE",
	attendanceTitleToday: "Asistencia de hoy",
	attendanceTitleYesterday: "Asistencia de ayer",
	attendanceTitleThisWeek: "Asistencia de esta semana",
	attendanceTitleThisMonth: "Asistencia de este mes",
	attendanceTitleCustom: "Asistencia del período seleccionado",
	attendanceTitleTodayKpis: "KPI de asistencia de hoy",
	attendanceTitleYesterdayKpis: "KPI de asistencia de ayer",
	attendanceTitleThisWeekKpis: "KPI de asistencia de esta semana",
	attendanceTitleThisMonthKpis: "KPI de asistencia de este mes",
	attendanceTitleCustomKpis: "KPI del período seleccionado",
	attendanceTrendDays: "Tendencia de asistencia — últimos {n} días",
	attendanceNotAttendedYet: "Aún no asistió",
	attendanceUpcomingAbsences: "Ausencias próximas",
	attendanceUpcomingAbsencesEmpty: "No hay ausencias próximas",
	attendanceUpcomingAbsencesTomorrow: "Mañana",
	attendanceUpcomingAbsencesInDays: "En {days} días",
	attendanceExceptions: "Excepciones de asistencia",
	attendanceExceptionsMissingCheckIn: "Entradas faltantes",
	attendanceExceptionsMissingCheckOut: "Salidas faltantes",
	attendanceExceptionsEarlyLeaves: "Salidas anticipadas",
	attendanceExceptionsUnapprovedAbsences: "Ausencias no aprobadas",
	attendanceExceptionsDuplicatePunches: "Fichajes duplicados",
	attendanceMonthlyKpis: "KPI mensuales de asistencia",
	attendanceKpiRate: "Tasa de asistencia",
	attendanceKpiAvgArrival: "Hora de llegada promedio",
	attendanceKpiLateArrivals: "Llegadas tarde",
	attendanceKpiAbsentDays: "Días de ausencia",
	attendanceKpiOvertimeHours: "Horas extra",
	attendanceLeaveBalanceOverview: "Resumen de saldo de vacaciones",
	attendanceLeaveBalanceVacationRemaining: "Vacaciones restantes",
	attendanceLeaveBalanceSickUsed: "Baja por enfermedad utilizada",
	attendanceLeaveBalanceBusinessTrips: "Viajes de negocios",
	attendanceLeaveBalancePendingRequests: "Solicitudes pendientes",
	attendanceLeaveBalanceCoverage: "{covered} de {total} empleados",
	attendanceTopInsights: "Principales datos de asistencia",
	attendanceInsightNoData: "Aún no hay datos disponibles",
	attendanceInsightHighestLateness: "{dept} tiene la tasa de tardanza más alta esta semana ({delta})",
	attendanceInsightFullAttendanceToday: "{dept} tiene 100% de asistencia",
	attendanceInsightTrendImproved: "La asistencia mejoró un {pct}% respecto al período anterior",
	attendanceInsightTrendDeclined: "La asistencia bajó un {pct}% respecto al período anterior",
	attendanceInsightApproachingOvertime: "{count} empleados se acercan a su límite de horas extra",
	attendancePreviousWeek: "Semana pasada",
	attendanceCurrentWeek: "Esta semana",
	attendanceAddInterval: "Añadir intervalo",
	attendanceBreakLabel: "Descanso",
	attendanceCorrectionMode: "Modo corrección",
	attendanceCustomIntervals: "Intervalos personalizados",
	attendanceDashboard: "Panel de asistencia",
	attendanceReports: "Informes",
	attendanceCalendarTab: "Calendario",
	reports: "Informes",
	shiftCoverage: "Cobertura de turnos",
	previousPeriod: "Período anterior",
	nextPeriod: "Período siguiente",
	failedToSave: "No se pudo guardar el comentario de horas extra",
	expandForDailyDetail: "Expandir fila para ver el detalle diario",
	noDataForPeriod: "No hay datos para este período",
	attendanceHistory: "Historial de asistencia",
	attendanceDayOffTab: "Día libre",
	attendanceDayType: "Tipo de día",
	attendanceDetectedIntervals: "Intervalos detectados",
	attendanceEditDay: "Editar día",
	attendanceHrsTotal: "h en total",
	attendanceViewWeek: "Semana",
	attendanceViewMonth: "Mes",
	attendanceViewDay: "Día",
	day: "Día",
	attendanceOpenFrom: "Abierto desde {time}",
	attendanceFromStillActive: "Desde {time} → sigue activo",
	attendanceTotalWorked: "Total trabajado",
	attendanceMissingUncovered: "Faltante / no cubierto",
	attendanceNoData: "Sin datos",
	attendanceNoDataForDay: "No hay datos de asistencia para este día.",
	attendanceIntervalApprovedOk: "Aprobado / OK",
	attendanceIntervalEachRowInvalid: "Indique hora de inicio y fin válidas para cada intervalo",
	attendanceIntervalTimesInvalid: "Indique hora de inicio y fin válidas",
	attendanceIntervalsMode: "Intervalos",
	attendanceIntervalsReviewHint:
		"Revise lo trabajado, las ausencias por permiso y los huecos. Añada abajo intervalos manuales para marcarlos como aprobados, trabajo, remoto, baja, vacaciones, no remunerado u otro.",
	attendanceLogSubtitle: "Entrada manual de asistencia — trabajo, bajas, vacaciones",
	attendanceLogTitle: "Registro de asistencia",
	attendanceManualResolutionIntervals: "Intervalos de corrección manual",
	attendanceMissingLabel: "Faltante",
	attendanceNoManualIntervalsYet: "Aún no hay intervalos manuales",
	attendanceNoUncovered: "No se detectaron intervalos sin cubrir",
	attendanceOptionalNotePlaceholder: "Nota opcional…",
	attendancePtoLeaveSection: "Permiso retribuido / permiso",
	attendanceReport: "Informe de asistencia",
	attendanceResolveInterval: "Resolver este intervalo",
	attendanceResyncTooltip: "Resincronizar la asistencia de este empleado",
	attendanceResyncSuccess: "Resincronización de asistencia iniciada",
	attendanceResyncFailed: "Error al resincronizar la asistencia",
	attendanceSavedSuccess: "Asistencia guardada correctamente",
	attendanceStatusUpcoming: "Próximo",
	attendanceSelectEmployeePrompt: "Seleccione un empleado para ver la asistencia",
	attendanceTrend: "Tendencia de asistencia",
	attendanceTrendPctPresent: "% Presentes",
	attendanceUncoveredMissing: "Sin cobertura / faltante",
	attendanceUnsavedChanges: "Cambios sin guardar",
	attendanceWholeDayStatus: "Estado del día completo",
	shiftWorker: "Trabajador por turnos",
	attendanceIgnoreMode: "Ignorar",
	attendanceIgnoreScopeWeekdays: "Días de la semana",
	attendanceIgnoreScopeDateRange: "Rango de fechas",
	attendanceIgnoreScopeWeekdaysHint: "Se aplica solo a los días de la semana seleccionados en este período.",
	attendanceIgnoreScopeDateRangeHint: "Se aplica a todos los días de este período.",
	attendanceIgnoreAppliesTo: "Se aplica a",
	attendanceIgnoreLateArrival: "Llegada tarde",
	attendanceIgnoreEarlyLeave: "Salida anticipada",
	attendanceIgnoreWindowStart: "Inicio de la ventana de exención",
	attendanceIgnoreWindowEnd: "Fin de la ventana de exención",
	attendanceIgnoreRulesList: "Reglas de exención",
	attendanceIgnoreRulesEmpty: "Aún no hay reglas de exención",
	attendanceIgnoreDaysOfWeekRequired: "Selecciona al menos un día",
	attendanceIgnoredLabel: "Exento",
	attendanceNoCardLabel: "Sin tarjeta",
	attendanceWork: "Trabajo",
	attendanceWorked: "Trabajado",
	attendanceWorkedIntervals: "Intervalos trabajados",
	attendanceMissingIntervals: "Intervalos faltantes",
	attendanceStillInOffice: "Todavía en la oficina",
	attendanceAddEvent: "Agregar evento",
	attendanceAddAttendanceEvent: "Agregar evento de asistencia",
	attendanceDeleteEventTitle: "¿Eliminar evento de asistencia?",
	attendanceDeleteEventText:
		"Esto elimina solo este evento de entrada/salida agregado manualmente.",
	attendanceNoMissingIntervals: "No hay intervalos faltantes para este día",
	attendanceOfficeSince: "Desde {time}",
	attendanceLastOutAt: "Última salida {time}",
	attendanceEventSingular: "evento",
	attendanceEventPlural: "eventos",
	attendancePunchIn: "Entrada",
	attendancePunchOut: "Salida",
	solveThis: "Resolver",
	editSolvedStatus: "Editar estado resuelto",
	officeStatus: "Estado en oficina",
	outOfOffice: "Fuera de la oficina",
	noPunches: "Sin registros",
	lastActionWasCheckIn: "La última acción fue entrada",
	lastActionWasCheckOut: "La última acción fue salida",
	noCheckInYet: "Aún no hay entrada",
	manual: "Manual",
	resolved: "Resuelto",
	attendanceManualStatusApplyTicketTimeTo: "Aplicar el tiempo del ticket a",
	attendanceManualStatusColumnAttendanceType: "Tipo de asistencia",
	attendanceManualStatusColumnTimeAction: "Acción de tiempo",
	attendanceManualStatusMapsToType: "Se asigna al tipo de asistencia",
	attendanceManualStatusTicketTimeAction: "Acción de tiempo de automatización del ticket",
	attendanceTicketTimePhraseAdd: "Añadir tiempo de {type}",
	attendanceTicketTimePhraseSubtract: "Restar tiempo de {type}",
	attendanceTimeOpAdd: "Añadir tiempo del ticket",
	attendanceTimeOpNone: "Sin cambio en el saldo de tiempo",
	attendanceTimeOpSubtract: "Restar tiempo del ticket",
	attendanceTypeOptionAbsent: "Ausente",
	attendanceTypeOptionBusinessTrip: "Viaje de negocios",
	attendanceTypeOptionHolidayNonWorking: "Festivo / no laborable",
	attendanceTypeOptionJustifiedAbsence: "Ausencia justificada (excusada)",
	attendanceTypeOptionMaternity: "Licencia de maternidad",
	attendanceTypeOptionPaidVacation: "Vacaciones pagadas",
	attendanceTypeOptionRemote: "Trabajo remoto",
	attendanceTypeOptionSickLeave: "Baja por enfermedad",
	attendanceTypeOptionUnjustifiedAbsence: "Ausencia injustificada (sin excusa)",
	attendanceTypeOptionUnpaidLeave: "Permiso sin sueldo",
	attendanceTypeOptionWork: "Trabajo",
	audio: "Audio",
	autoDeletion: "Eliminación automática",
	averageDailyHours: "Horas diarias promedio",
	avgDaily: "Promedio diario",
	avgDailyHours: "Horas diarias promedio",
	avgHoursPerWorkingDay: "Horas promedio por dia laboral",
	avgOrderValue: "Valor promedio del pedido",
	avgResolutionTime: "Tiempo promedio de resolución",
	avgResponseTime: "Tiempo promedio de respuesta",
	avgTracksPerPlaylist: "Promedio pistas/lista",
	back: "Volver",
	bank: "Banco",
	bankAccount: "Cuenta bancaria",
	bankCart: "Tarjeta bancaria",
	bankEmitet: "Banco",
	banner: "Banner",
	baseSalary: "Salario base",
	baseSalaryHourlyLinked:
		"Actualiza la tarifa horaria desde la base ÷ horas regulares (si horas > 0).",
	basicInformation: "Información básica",
	beginningOfAcquaintance: "Inicio del conocimiento",
	beginningOfContract: "Inicio del contrato",
	beginningOfTraining: "Inicio de la formación",
	benefits: "Beneficios",
	bestSeller: "Más vendido",
	bestSellers: "Más vendidos",
	bestSellingItemsByRevenue: "Artículos más vendidos por ingresos",
	bitrate: "Tasa de bits",
	biweekly: "Quincenal",
	blogItems: "Elementos del blog",
	blogs: "Blogs",
	bonuses: "Bonificaciones",
	bpm: "BPM",
	branch: "Sucursal de red eléctrica",
	branches: "Lista de sucursales",
	branchesCitiesVillages: "Sucursales, Ciudades, Pueblos",
	brand: "Marca",
	brands: "Marcas",
	building: "Edificio",
	businessTrip: "Viaje de negocios",
	buttonText: "Texto del botón",
	bypassSteps: "Omitir pasos",
	calAddCalendarTooltip: "Crea un calendario y compártelo",
	calAddEvent: "Añadir evento",
	calAddReminder: "Añadir recordatorio",
	calAlarm15m: "15 minutos antes",
	calAlarm1d: "1 día antes",
	calAlarm1h: "1 hora antes",
	calAlarm1w: "1 semana antes",
	calAlarm2d: "2 días antes",
	calAlarm2h: "2 horas antes",
	calAlarm30m: "30 minutos antes",
	calAlarm5m: "5 minutos antes",
	calAlarmAtEvent: "A la hora del evento",
	calAllDay: "Todo el día",
	calApiNotConfigured: "La API del calendario no está configurada.",
	calCalendarColorLabel: "Color del calendario",
	calCalendarCreateFailed: "No se pudo crear el calendario",
	calCalendarCreated: "Calendario creado",
	calCalendarDeleted: "Calendario eliminado",
	calCalendarNameLabel: "Nombre del calendario",
	calCalendarNamePh: "p. ej. Planificación del equipo",
	calCalendarNameRequired: "Introduzca un nombre de calendario",
	calCalendarSelect: "Calendario",
	calCalendarUpdateFailed: "No se pudo actualizar el calendario",
	calCalendarUpdated: "Calendario actualizado",
	calCalendarsLabel: "Calendarios:",
	calGoogleCalendarLabel: "Google Calendar:",
	calGoogleCalendarPrefix: "Google",
	calMeetingsLabel: "Reuniones:",
	calCancel: "Cancelar",
	calCheckAll: "Seleccionar todo",
	calColor: "Color",
	calCreateCalendar: "Crear calendario",
	calDay: "Día",
	calDayOverviewTitle: "Día",
	calDefaultCalendarName: "Calendario",
	calDelete: "Eliminar",
	calDeleteCalendarHasEvents:
		"Este calendario tiene {count} evento(s). ¿Qué desea hacer con ellos?",
	calDeleteCalendarNoEvents: "Esta acción no se puede deshacer.",
	calDeleteCalendarOnly: "Eliminar solo el calendario",
	calDeleteCalendarTitle: "¿Eliminar el calendario?",
	calDeleteCalendarWithEvents: "Eliminar con eventos",
	calDeleteEventText: "Esta acción no se puede deshacer.",
	calDeleteEventTitle: "¿Eliminar evento?",
	calDeleteFailed: "Error al eliminar",
	calDescription: "Descripción",
	calDescriptionPh: "Descripción opcional",
	calEditCalendarTitle: "Editar calendario",
	calEditCalendarTooltip: "Editar calendario",
	calEditEvent: "Editar evento",
	calEditTooltip: "Editar",
	calEnd: "Fin",
	calEndBeforeStart: "El fin no puede ser antes del inicio",
	calEndTime: "Hora de fin",
	calEvent: "Evento",
	calEventCreated: "Evento creado",
	calEventDeleted: "Evento eliminado",
	calEventTitle: "Título",
	calEventTitlePh: "Título del evento",
	calEventUpdated: "Evento actualizado",
	calEventsPlural: "eventos",
	calExportIcs: "Exportar .ics",
	calFailedLoadEvents: "Error al cargar eventos",
	calHrBirthdayEvent: "Cumpleaños",
	calHrBirthdays: "Cumpleaños",
	calHrContractEnd: "Fin de contrato",
	calHrContractEndEvent: "Fin de contrato",
	calHrContractStart: "Inicio de contrato",
	calHrContractStartEvent: "Inicio de contrato",
	calHrIdEvent: "Vencimiento del DNI",
	calHrIdExpiry: "Vencimiento del DNI",
	calHrPassportEvent: "Vencimiento del pasaporte",
	calHrPassportExpiry: "Vencimiento del pasaporte",
	calHrPositionReview: "Revisión de puesto",
	calHrPositionReviewEvent: "Revisión de puesto",
	calHrSalaryReview: "Revisión salarial",
	calHrSalaryReviewEvent: "Revisión salarial",
	calImportButton: "Importar",
	calImportEventsTitle: "Importar eventos",
	calImportFoundInFile: "encontrados en el archivo. Elija un calendario:",
	calImportIcs: "Importar .ics",
	calImportedEventTitle: "Evento importado",
	calItLabel: "TI:",
	calItWarrantyEnd: "Fin de garantía",
	calItWarrantyEndEvent: "Fin de garantía",
	calMonth: "Mes",
	calNewCalendarTitle: "Nuevo calendario",
	calNewEvent: "Nuevo evento",
	calNoCalendar: "Sin calendario",
	calNoCalendarUncategorised: "Sin calendario (sin categoría)",
	calNoEventsInIcs: "No hay eventos en el .ics",
	calNoEventsThisDay: "No hay eventos este día.",
	calNoRemindersThisDay: "No hay recordatorios este día.",
	calDayWeatherMap: "Mapa del tiempo",
	calDayHourlyForecast: "Pronóstico por horas",
	calDayWeatherUnavailable: "Pronóstico no disponible para esta fecha",
	calDayEventsSection: "Eventos",
	calDayRemindersSection: "Recordatorios",
	calOpenProfile: "Abrir perfil",
	calPeopleLabel: "Personas:",
	calReminders: "Recordatorios",
	calRemindersLabel: "Recordatorios:",
	calAttendanceLabel: "Asistencia:",
	calSecurityLabel: "Seguridad:",
	calSecurityAlerts: "Alertas",
	calSecuritySessions: "Sesiones",
	calSecurityTokenExpiry: "Expiración de token",
	calRemindersToggle: "Recordatorios activos",
	calSave: "Guardar",
	calSaveFailed: "Error al guardar",
	calShareWithUsers: "Compartir con usuarios",
	calShareWithUsersPh: "Buscar y seleccionar personas",
	calStart: "Inicio",
	calStartEndRequired: "Se requiere inicio y fin",
	calStartTime: "Hora de inicio",
	calSwalDelete: "Eliminar",
	calTaskHigh: "Alto",
	calTaskLow: "Bajo",
	calTaskMedium: "Medio",
	calTaskUrgent: "Urgente",
	calTasksLabel: "Tareas:",
	calTicketsLabel: "Tickets:",
	calToday: "Hoy",
	calUserFallback: "Usuario",
	calWeek: "Semana",
	calculatePayroll: "Calcular nómina",
	calculated: "Calculado",
	calculations: "Cálculos",
	calendarEventType: "Evento del calendario",
	calling: "Llamando",
	cancel: "Cancelar",
	clearText: "Borrar texto",
	cancelAction: "Cancelar acción",
	cancelBack: "Cancelar vuelta",
	cancelled: "Cancelado",
	cannotBeUndone: "Esta acción no se puede deshacer.",
	cannotPayOnline: "No se puede pagar en línea",
	cart: "Empleados",
	categories: "Categorías",
	category: "Categoría",
	categoryPerformance: "Rendimiento de categoría",
	certificate: "Certificado",
	certificateImages: "Imágenes de certificado",
	certificates: "Certificados",
	changedDate: "Fecha de cambio",
	channel: "Canal",
	channelWritePermissionDescription: "Solo los administradores del chat pueden escribir mensajes",
	channels: "Canales",
	charts: "Gráficos",
	chatActions: "acciones del chat",
	chatActiveLabel: "activo...",
	chatAddOption: "Agregar opcion",
	chatAddUsers: "Agregar usuarios",
	chatAddedToGroupNotification: "Agregado al chat grupal",
	chatAddedYouToGroup: "te agrego a",
	chatAudioCall: "llamada de audio",
	chatBulkDeleteFailed: "Fallo la eliminacion masiva.",
	chatBulkForwardFailed: "Fallo el reenvio masivo.",
	chatCallMessage: "Mensaje de llamada",
	chatChoosingEmoji: "eligiendo emoji...",
	chatClickMapToChoosePoint: "Haz clic en el mapa para elegir un punto personalizado.",
	chatCoordinatesUnavailable: "Coordenadas no disponibles",
	chatCopyCoordinates: "Copiar coordenadas",
	chatCopyCoordinatesFailed: "No se pudieron copiar las coordenadas.",
	chatCreatePoll: "Crear encuesta",
	chatCurrent: "Actual",
	chatCurrentLocation: "Ubicacion actual",
	chatDashboard: "Panel de chat",
	chatDeleteFailed: "Error al eliminar",
	chatDeleteForMeOnly: "Eliminar solo para mi",
	chatDeleteForParticipants: "Eliminar tambien para participantes",
	chatDeleteLocation: "Eliminar ubicacion",
	chatDeleteSelectedMessagesDescription:
		"Esta accion elimina los mensajes seleccionados de tu vista de chat. Los mensajes que no se puedan eliminar con tus permisos actuales se marcaran como fallidos.",
	chatDeleteSelectedMessagesTitle: "Eliminar mensajes seleccionados",
	chatDeletionPartialWarning:
		"Los resultados de eliminacion pueden ser parciales si algunos mensajes ya fueron eliminados o fallan las verificaciones de permisos.",
	chatDepartmentSaveFailed: "No se pudo actualizar el departamento",
	chatDepartmentSaveFailedTryAgain: "Intenta actualizar el departamento nuevamente.",
	chatDeselectAllMessages: "Deseleccionar todo",
	chatDestinationChatsLabel: "Chats de destino",
	chatDestinationChatsPlaceholder: "Selecciona uno o mas chats",
	chatDirect: "Chat directo",
	chatDirectChat: "Chat directo",
	chatEditFailed: "No se pudo editar el mensaje",
	chatEditFailedTryAgain: "Intenta editar de nuevo.",
	chatEditMessagePlaceholder: "Editar mensaje...",
	writeMessage: "Escribe un mensaje...",
	chatEditingMessage: "Editando mensaje",
	chatExitSelectionMode: "Salir del modo de seleccion",
	chatExpired: "Expirado",
	chatForwardFailed: "Error al reenviar",
	chatForwardSelectedMessagesTitle: "Reenviar mensajes seleccionados",
	chatForwardableLabel: "reenviables",
	chatGeolocationUnavailable: "La geolocalizacion no esta disponible en este navegador.",
	chatGroupChat: "chat grupal",
	chatGroupInfo: "Informacion del grupo",
	chatGroupMembers: "Miembros del grupo",
	chatGroupSettings: "Configuracion del grupo",
	chatGroupSettingsDescription:
		"Configura la imagen del grupo y el departamento de RR. HH. vinculado",
	chatID: "ID de chat",
	chatImageUploadFailed: "Error al subir la imagen",
	chatImageUploadFailedTryAgain: "Intenta subir una imagen diferente.",
	chatIncludeLabel: "Incluir",
	chatIsChoosingEmoji: "esta eligiendo emoji...",
	chatIsTyping: "esta escribiendo...",
	chatLastUpdated: "Ultima actualizacion",
	chatLatitude: "Latitud",
	chatLive: "En vivo",
	chatLiveFor: "En vivo por",
	chatLiveLocation: "Ubicacion en vivo",
	chatLiveLocationOptInWarning:
		"La ubicacion en vivo requiere activacion explicita y puede detenerse en cualquier momento.",
	chatLiveLocationSharingActive: "El uso compartido de ubicacion en vivo esta activo",
	chatLoadingLocation: "Cargando ubicacion...",
	chatLoadingPoll: "Cargando encuesta...",
	chatLongitude: "Longitud",
	chatMessagesCannotBeForwarded: "mensaje(s) no se pueden reenviar y se omitiran.",
	chatMessagesDeleted: "Mensajes eliminados",
	chatMessagesForwarded: "Mensajes reenviados",
	chatMoreActions: "Mas acciones",
	chatNoAvailableUsersToAdd: "Todos los usuarios disponibles ya estan en este grupo.",
	chatNoBackground: "Sin fondo",
	chatNoChatsFound: "No se encontraron chats",
	chatNoMessagesForwarded: "No se pudo reenviar ningun mensaje.",
	chatNoSelectedMessagesDeleted: "No se pudo eliminar ningun mensaje seleccionado.",
	chatOpenDepartmentPage: "Abrir pagina del departamento",
	chatOpenMap: "Abrir mapa",
	chatOptionalAddressLabel: "Etiqueta de direccion opcional",
	chatOwnMessagesLabel: "propios",
	chatPartialDelete: "Eliminacion parcial",
	chatPartialForward: "Reenvio parcial",
	chatPattern: "Patron",
	chatPickOnMap: "Elegir en el mapa",
	chatPickPointOnMap: "Elige un punto en el mapa.",
	chatPinnedLocation: "Ubicacion fijada",
	chatPollAddAnotherOption: "Agregar otra opcion",
	chatPollAddOptionFailed: "No se pudo agregar la opcion.",
	chatPollAllowAddingOptions: "Permitir agregar opciones",
	chatPollAllowMultipleAnswers: "Permitir multiples respuestas",
	chatPollAllowRevote: "Permitir volver a votar",
	chatPollAnonymous: "Encuesta anonima",
	chatPollAnonymousCannotAddOptions: "Un cuestionario anonimo no puede permitir agregar opciones.",
	chatPollAtLeastOptions: "Minimo de opciones requeridas:",
	chatPollAutoClose: "Cierre automatico",
	chatPollChangeVote: "Cambiar voto",
	chatPollChooseCorrectAnswer: "Elige al menos una respuesta correcta para el cuestionario.",
	chatPollCloseDate: "Fecha de cierre",
	chatPollCloseDateOrOpenPeriod: "Usa fecha de cierre o periodo abierto, no ambos.",
	chatPollCloseFailed: "No se pudo cerrar la encuesta.",
	chatPollClosePoll: "Cerrar encuesta",
	chatPollCorrectAnswer: "Respuesta correcta",
	chatPollCorrectAnswers: "Respuestas correctas",
	chatPollCreateFailed: "No se pudo crear la encuesta.",
	chatPollDeletePoll: "Eliminar encuesta",
	chatPollDescriptionMax: "La descripcion debe tener como maximo",
	chatPollExplanationMax: "La explicacion debe tener como maximo",
	chatPollHideResultsUntilClosed: "Ocultar resultados hasta cerrar",
	chatPollIncorrectAnswer: "Respuesta incorrecta",
	chatPollLeaveEmptyKeepOpen: "Dejar vacio para mantener la encuesta abierta",
	chatPollLeaveEmptyNoTimer: "Dejar vacio para no usar temporizador",
	chatPollLoadVotersFailed: "No se pudieron cargar los votantes.",
	chatPollMultipleChoice: "Opcion multiple",
	chatPollNewOption: "Nueva opcion",
	chatPollNoVoteYet: "Aun sin voto",
	chatPollNoVotersForOption: "No se encontraron votantes para esta opcion.",
	chatPollOpenPeriod: "Periodo abierto",
	chatPollOptionMax: "La opcion debe tener como maximo",
	chatPollOptionRequired: "La opcion es obligatoria.",
	chatPollOptionsUnique: "Las opciones deben ser unicas.",
	chatPollPublic: "Publico",
	chatPollQuestionMax: "La pregunta debe tener como maximo",
	chatPollQuestionRequired: "La pregunta es obligatoria.",
	chatPollQuiz: "Cuestionario",
	chatPollQuizExplanation: "Explicacion del cuestionario",
	chatPollRegular: "Normal",
	chatPollResultsHiddenUntilClosed: "Los resultados se ocultan hasta que se cierre la encuesta.",
	chatPollSearchVoters: "Buscar votantes",
	chatPollShuffleOptions: "Mezclar opciones",
	chatPollSingleChoice: "Opcion unica",
	chatPollSingleChoiceOneCorrect:
		"Un cuestionario de opcion unica solo puede tener una respuesta correcta.",
	chatPollSubmitVoteFailed: "No se pudo enviar tu voto.",
	chatPollViewVoters: "Ver votantes",
	chatPollVoteRecorded: "Voto registrado",
	chatPollVotersLabel: "votantes",
	chatPollVotersTitle: "Votantes de la encuesta",
	chatPollYouVoted: "Has votado.",
	chatPollYouVotedCanChange: "Has votado y puedes cambiar tu respuesta.",
	chatPreviewChronological: "Vista previa (cronologico)",
	chatProvider: "Proveedor",
	chatReadCurrentLocationFailed: "No se pudo leer tu ubicacion actual.",
	chatRefreshCurrentLocation: "Actualizar ubicacion actual",
	chatRuleAllow: "Si",
	chatRuleDeny: "No",
	chatRuleTimed: "Si, pero solo por tiempo limitado",
	chatRuleTimerDescription:
		"Ejemplo: pon 1 para permitir la accion solo durante el primer minuto despues del envio.",
	chatRuleTimerMinutes: "Temporizador en minutos",
	chatSearchMessage: "Buscar mensaje",
	chatSelectAllMessages: "Seleccionar todo",
	chatSelectDepartment: "Selecciona el departamento de RR. HH.",
	chatSelectOrLoadLocationFirst: "Selecciona o carga primero una ubicacion.",
	chatSelectRepeatingBackground: "Selecciona un fondo repetitivo",
	chatSelectUsersToAdd: "Selecciona usuarios para agregar",
	chatSelectedLabel: "seleccionados",
	chatSelectionMode: "Modo de seleccion",
	chatSendCurrentLocation: "Enviar ubicacion actual",
	chatSendLocationFailed: "Error al enviar la ubicacion.",
	chatSendPinnedLocation: "Enviar ubicacion fijada",
	chatSendVenue: "Enviar lugar",
	chatSentAt: "Enviado",
	chatSettings: "Configuracion del chat",
	chatSettingsEditRule: "Editar mensajes",
	chatSettingsEditRuleDescription:
		"Elige si los mensajes enviados pueden editarse siempre, nunca, o solo por un tiempo limitado.",
	chatSettingsForwardRule: "Reenviar mensajes",
	chatSettingsForwardRuleDescription:
		"Permite reenviar siempre, nunca, o solo durante un tiempo limitado despues del envio original.",
	chatSettingsGlobalPageSubtitle:
		"Configura aqui una vez las reglas de los chats personales. Solo los administradores pueden configurar las reglas de su grupo.",
	chatSettingsGlobalPageTitle: "Configuracion global del chat",
	chatSettingsGlobalRulesDescription:
		"Estas reglas se aplican a todos los chats personales.",
	chatSettingsGlobalSavedSuccess: "La configuracion global del chat se actualizo correctamente",
	chatSettingsCompactMode: "Modo compacto",
	chatSettingsCompactModeDescription:
		"Reduce el espaciado y el tamano de los avatares para mostrar mas chats en la barra lateral.",
	chatSettingsSidebarDescription: "Controla como se muestran los chats en la barra lateral izquierda.",
	chatSettingsSidebarTitle: "Barra lateral del chat",
	chatSettingsShowLastMessage: "Mostrar ultimo mensaje",
	chatSettingsShowLastMessageDescription:
		"Muestra la vista previa del ultimo mensaje y su fecha u hora en la barra lateral del chat.",
	chatSettingsReplyRule: "Responder mensajes",
	chatSettingsReplyRuleDescription:
		"Controla si los miembros pueden responder siempre, nunca, o solo durante una ventana de tiempo tras el envio.",
	chatSettingsResetToGlobal: "Restaurar reglas predeterminadas del grupo",
	chatSettingsRulesAdminOnly: "Solo los administradores del chat pueden cambiar estas reglas.",
	chatSettingsRulesDescription:
		"Configura si los miembros pueden reenviar, responder o editar mensajes, con limite de tiempo si hace falta.",
	chatSettingsRulesTitle: "Reglas del chat",
	chatSettingsSaveFailed: "No se pudieron guardar los ajustes del chat",
	chatSettingsSaveFailedTryAgain: "Intentalo de nuevo.",
	chatSettingsUsingCustomRules:
		"Este grupo usa las reglas establecidas por sus administradores.",
	chatSettingsUsingGlobalRules: "Este grupo usa las reglas predeterminadas.",
	chatShareLocation: "Compartir ubicacion",
	chatSkipLabel: "Omitir",
	chatSkippedLabel: "omitidos",
	chatStartCall: "Iniciar llamada",
	chatStartLiveSharing: "Iniciar comparticion en vivo",
	chatStopLiveSharing: "Detener comparticion en vivo",
	chatType: "Tipo de chat",
	chatTypeToSearch: "Escribe para buscar",
	chatTyping: "escribiendo...",
	chatUnnamedChat: "Chat sin nombre",
	chatUpdatingSharedLocationFor: "Actualizando esta ubicacion compartida por",
	chatUploadGroupImage: "Subir imagen del grupo",
	chatUserInfo: "Informacion del usuario",
	chatUsersSaveFailed: "No se pudieron agregar los usuarios",
	chatUsersSaveFailedTryAgain: "Intenta agregar nuevamente a los usuarios seleccionados.",
	chatVenue: "Lugar",
	chatVenueTitle: "Titulo del lugar",
	chatVideoCall: "videollamada",
	chatViewReportedMessages: "Ver mensajes reportados",
	chatWaitingDeviceCoordinates: "Esperando coordenadas del dispositivo...",
	childcarePayment: "Pago de guardería",
	chooseBoard: "Seleccione Board para ver sus categorías y tareas",
	cities: "Ciudades",
	city: "Ciudad",
	clear: "Borrar",
	clearFilters: "Borrar filtros",
	clickTheButtonBelowToTakeTheNextStepOnYourJourney:
		"Haz clic en el botón de abajo para dar el siguiente paso en tu viaje",
	contact: "Cliente",
	contactEngagement: "Compromiso del cliente",
	contactGroup: "Grupo de clientes",
	contactGroups: "Grupos de clientes",
	contactPlaylist: "Lista de reproducción del cliente",
	contactProfile: "Perfil de cliente",
	contacts: "clientes",
	contactsByGender: "Clientes por género",
	contactsByGroup: "Clientes por grupo",
	contactsUsing: "clientes usando",
	contactsWithCarts: "Clientes con carritos",
	contactsWithFavorites: "Clientes con favoritos",
	clockInOut: "Entrada / Salida",
	close: "Cerrar",
	closeNavigation: "Cerrar navegación",
	closeTicket: "Cerrar ticket",
	closed: "Cerrado",
	closed_late: "Cerrado después de la fecha límite",
	closedDate: "Fecha de cierre",
	closedTickets: "Billetes cerrados",
	cmDashboard: "Panel de CM",
	code: "Código",
	coin: "Moneda",
	coinBurnTime: "Tiempo de quema de monedas",
	coinCount: "Cantidad de monedas",
	color: "Color",
	comment: "Comentario",
	commentTicket: "Comentario de ticket",
	commissions: "Comisiones",
	communicationPreferences: "Preferencias de comunicación",
	community: "Comunidad",
	company: "Compañía",
	completed: "Completado",
	completedDate: "Fecha de finalización",
	completedTasks: "Tareas completadas",
	completionRate: "tasa de finalización",
	confirm: "Confirmar",
	confirmAction: "Confirmar acción",
	contactForm: "Formulario de contacto",
	contactForms: "Formularios de contacto",
	contactType: "Tipo de contacto",
	contacts: "Contactos",
	contentByType: "Contenido por tipo",
	contentItems: "Elementos de contenido",
	contentManagementOverview: "Resumen del sistema de gestión de contenido",
	contentOverTime: "Contenido creado a lo largo del tiempo (últimos 30 días)",
	continue: "Continuar",
	contract: "Contrato",
	contractEndDate: "Fecha de finalización del contrato",
	contractStartDate: "Fecha de inicio del contrato",
	contractor: "Contratista",
	copy: "Copiar",
	costOfBuildingPart: "Costo de la parte de construcción",
	costOfBuildingPermit: "Costo del permiso de construcción",
	country: "País",
	cpu: "CPU",
	create: "Orden",
	createBoard: "Crear un nuevo tablero",
	createChat: "Crear chat",
	createGroupChat: "Crear chat grupal",
	createGroupSubmit: "Crear",
	addNewCategory: "Agregar nueva categoría",
	createNewCategory: "Crear una nueva categoría",
	created: "Creado",
	createdAt: "Creado el",
	createdBy: "Creado por",
	createdByUser: "Creado por el usuario",
	critical: "Crítico",
	crmDashboard: "Panel de CRM",
	cta1: "Llamada a la acción sección 1",
	cta2: "Llamada a la acción sección 2",
	cta3: "Llamada a la acción sección 3",
	currency: "Moneda",
	currentlyStreaming: "transmitiendo actualmente",
	currentlyWorking: "Trabajando ahora",
	custom: "Personalizado",
	customerAcquisition: "Adquisición de clientes",
	customerBaseOverview: "Resumen de la base de clientes",
	customerInsights: "Información del cliente",
	customerRelationshipOverview: "Resumen de la gestión de relaciones con clientes",
	dashboard: "Tablero",
	dashboardSubtitle: "Subtítulo del panel",
	database: "Base de datos",
	date: "Fecha",
	dateOfBirth: "Fecha de nacimiento",
	dates: "Fechas",
	datingAttendance: "Asistencia a citas",
	dayOff: "Día libre",
	meeting: "Reunión",
	dayOffForAllEmployees: "Día libre para todos los empleados",
	dayOffRemoved: "Día libre eliminado",
	dayOffSavedForAllEmployees: "Día libre guardado para todos los empleados",
	days: "días",
	daysLeft: "días restantes",
	daysOfWeek: "Días de la semana",
	daysWorked: "Dias trabajados",
	deadLine: "Fecha límite",
	deadline: "Fecha límite",
	debt: "Deuda",
	decline: "Rechazar",
	deductions: "Deducciones",
	defaultEnergyMax: "Energía máxima por defecto",
	defaultEnergyMin: "Energía mínima por defecto",
	defaultStream: "Flujo predeterminado",
	defaultStreams: "Transmisiones predeterminadas",
	defaultStreamsDesc: "transmisiones predeterminadas",
	delays: "Retrasos",
	delete: "Eliminar",
	deleteForEveryone: "Eliminar para todos",
	deletePermanently: "Eliminar permanentemente",
	deleteRule: "Eliminar regla",
	deleteSelected: "Eliminar seleccionados",
	delivery: "Entrega",
	deliveryAddress: "Dirección de entrega",
	deliveryMethod: "Método de entrega",
	density: "Densidad",
	department: "Departamento",
	departmentChatsHelp:
		"Vincule chats de grupo y canales a este departamento. Se mantiene sincronizado con el campo de departamento de cada chat.",
	departmentLinkedChats: "Chats del departamento",
	departments: "Departamentos",
	desc: "Descripción",
	description: "Descripción",
	designer: "Diseñador",
	detailedFilters: "Filtros detallados",
	detailedSteps: "Pasos detallados",
	details: "Detalles",
	developed: "Desarrollado",
	developedBy: "Desarrollado por",
	difference: "Diferencia",
	diplomaImages: "Imágenes de diploma",
	directMessages: "Mensajes directos",
	disableSteps: "Deshabilitar pasos",
	disabledSteps: "Pasos deshabilitados",
	disk: "Disco",
	distributionByPaymentType: "Distribución por tipo de pago",
	domainFacility: "Instalaciones",
	domainFinance: "Finanzas",
	domainHR: "RRHH",
	domainIT: "IT",
	domainOther: "Otro",
	domainSecurity: "Seguridad",
	done: "Hecho",
	download: "Descargar",
	downloadAsContact: "Descargar como contacto",
	draft: "Borrador",
	dragToReorder: "Arrastra para reordenar",
	dropFilesHere: "Arrastra los archivos aquí",
	dropFilesHereOrClick: "Arrastra los archivos aquí o haz clic para añadir más",
	dropzoneText: "Arrastra las imágenes aquí o haz clic para seleccionar archivos",
	dueDate: "Fecha de vencimiento",
	duration: "Duración",
	ecommerceDashboard: "Panel de control de la venta en línea",
	edit: "Editar",
	editComment: "Editar comentario",
	editItem: "Editar elemento",
	editProject: "Editar proyecto",
	editRule: "Editar regla",
	edited: "Editado",
	editingRule: "Editar regla",
	email: "Correo electrónico",
	sendEmail: "Enviar correo",
	employee: "Empleado",
	employeesPerDepartment: "Empleados por departamento",
	employerExpenses: "Gastos del empleador",
	employmentStatus: "Estado de empleo",
	emptyTrash: "Vaciar la papelera",
	end: "Fin",
	endDate: "Fecha de finalización",
	endDateMustBeLaterThanStartDate:
		"La fecha de finalización debe ser posterior a la fecha de inicio",
	endDateShort: "Fecha de finalización",
	endOfTraining: "Fin de la formación",
	endTime: "Hora de fin",
	ends: "Termina",
	energyLevel: "Nivel de energía",
	energyScheduling: "Planificación energética",
	enterAmount: "Introducir cantidad",
	enterFeatureSuffix: "Introducir sufijo de función",
	enterFeatureText: "Introducir texto de función",
	enterGroupName: "Introduzca el nombre del grupo...",
	enterLabel: "Introducir etiqueta",
	enterPersons: "Introducir número de personas",
	enterRuleName: "Introducir nombre de regla",
	entry: "Entrada",
	error: "Error",
	errorMessage: "Ocurrió un error, por favor intente nuevamente.",
	errorOccurred: "Ocurrió un error",
	errorPageButton: "Llévame a casa",
	errorPageHelpText: "¿Necesitas ayuda? Contacta a nuestro equipo de soporte",
	errorPageSecondaryButton: "Reportar este problema",
	errorPageSubtitle: "La página que buscas no existe",
	errorPageText:
		"¡No te preocupes, le pasa a los mejores! La página pudo haber sido movida, eliminada, o quizás ingresaste una URL incorrecta. Te ayudamos a volver al camino correcto.",
	errorPageTitle: "¡Ups! Algo salió mal",
	errorUserNotFound: "Usuario no encontrado",
	estimatedHours: "Horas estimadas",
	eventType: "Tipo de evento",
	exit: "Salida",
	expectedSalary: "Salario esperado",
	expireDate: "Fecha de vencimiento",
	expired: "Caducado",
	expiresOn: "Expira el",
	expiringIdCards: "Tarjetas de identificación que están por expirar",
	expiringPassports: "Pasaportes que están por expirar",
	export: "Exportar",
	exportData: "Exportar datos",
	extraLarge: "Extra grande",
	extraSmall: "Extra pequeño",
	faqQuestions: "Preguntas FAQ",
	favorites: "Favoritos",
	features: "Funcionalidades",
	female: "Mujer",
	fields: "Campos",
	file: "Archivo",
	fileHasBeenRemoved: "El archivo ha sido eliminado",
	fileMovedToTrash: "El archivo se moverá a la papelera",
	fileRestored: "Archivo restaurado",
	fileWillBeMovedToTrash: "El archivo se moverá a la papelera",
	files: "Archivos",
	filesRestored: "Archivos restaurados",
	filesWillBePermanentlyDeleted: "archivos se eliminarán de forma permanente.",
	filter: "Filtro",
	filterBy: "Filtro",
	filters: "Filtros",
	finish: "Terminar",
	fired: "Despedido",
	firstIn: "Primera entrada",
	firstName: "Nombre",
	forgotPassword: "¿Olvidaste tu contraseña?",
	forward: "Reenviar",
	forwardMessage: "Reenviar mensaje",
	forwarded: "Reenviado",
	forwardedFrom: "Reenviado desde",
	fri: "Viernes",
	from: "De",
	fromAttendanceLogs:
		"Relleno desde los registros de asistencia de este empleado y período; puedes ajustar.",
	fromDb: "Desde la base de datos",
	fromHrSettings: "Configuración de RR. HH.",
	gallery: "Galería",
	genderDistribution: "Distribución de género",
	globalFilter: "Filtro global",
	globalSearchClose: "Cerrar",
	globalSearchCmd_goCalendar_desc: "Eventos del calendario",
	globalSearchCmd_goCalendar_label: "Ir al calendario",
	globalSearchCmd_goChat_desc: "Abrir mensajería",
	globalSearchCmd_goChat_label: "Ir al chat",
	globalSearchCmd_goCrm_desc: "Gestión de clientes",
	globalSearchCmd_goCrm_label: "Ir al CRM",
	globalSearchCmd_goFinance_desc: "Módulo financiero",
	globalSearchCmd_goFinance_label: "Ir a Finanzas",
	globalSearchCmd_goHr_desc: "Módulo de RR. HH.",
	globalSearchCmd_goHr_label: "Ir a RR. HH.",
	globalSearchCmd_goIt_desc: "Equipamiento TI",
	globalSearchCmd_goIt_label: "Ir a TI",
	globalSearchCmd_goProjects_desc: "Base de datos de proyectos",
	globalSearchCmd_goProjects_label: "Ir a proyectos",
	globalSearchCmd_goRadio_desc: "Música y listas",
	globalSearchCmd_goRadio_label: "Ir a la radio",
	globalSearchCmd_goTickets_desc: "Sistema de tickets",
	globalSearchCmd_goTickets_label: "Ir a tickets",
	globalSearchCmd_goTodo_desc: "Tableros y tareas",
	globalSearchCmd_goTodo_label: "Ir a tareas",
	globalSearchCmd_messageUser_desc: "Abrir chat para enviar",
	globalSearchCmd_messageUser_label: "Mensaje a usuario",
	globalSearchCmd_newContact_desc: "Añadir cliente CRM",
	globalSearchCmd_newClient_label: "Nuevo cliente",
	globalSearchCmd_newOrder_desc: "Crear pedido",
	globalSearchCmd_newOrder_label: "Nuevo pedido",
	globalSearchCmd_newProject_desc: "Crear proyecto",
	globalSearchCmd_newProject_label: "Nuevo proyecto",
	globalSearchCmd_newTask_desc: "Crear tarea",
	globalSearchCmd_newTask_label: "Nueva tarea",
	globalSearchCmd_newTicket_desc: "Crear ticket",
	globalSearchCmd_newTicket_label: "Nuevo ticket",
	globalSearchCommandBadge: "Comando",
	globalSearchCommands: "Comandos",
	globalSearchCopied: "¡Copiado!",
	globalSearchCopyLink: "Copiar enlace",
	globalSearchDirectMessage: "Mensaje directo",
	globalSearchFilterAll: "Todo",
	globalSearchFilterCalendar: "Calendario",
	globalSearchFilterChats: "Chats",
	globalSearchFilterDevices: "Dispositivos",
	globalSearchFilterEcom: "Comercio electrónico",
	globalSearchFilterFinance: "Finanzas",
	globalSearchFilterPeople: "Personas",
	globalSearchFilterProjects: "Proyectos",
	globalSearchFilterRadio: "Radio",
	globalSearchFilterTickets: "Tickets",
	globalSearchFilterTodo: "Tareas",
	globalSearchHidePreview: "Ocultar vista previa",
	globalSearchNavigate: "Navegar",
	globalSearchOpen: "Abrir",
	globalSearchOpenInNewTab: "Abrir en una pestaña nueva",
	globalSearchPageBadge: "Página",
	globalSearchPlaceholder:
		"Buscar cualquier cosa en APIT (usuarios, tickets, chats, dispositivos…)",
	globalSearchPreviewAddress: "Dirección",
	globalSearchPreviewArtist: "Artista",
	globalSearchPreviewChat: "Chat",
	globalSearchPreviewCompany: "Empresa",
	globalSearchPreviewCreated: "Creado",
	globalSearchPreviewDeviceId: "ID dispositivo",
	globalSearchPreviewEmail: "Correo",
	globalSearchPreviewEmployeeNumber: "N.º empleado",
	globalSearchPreviewEnd: "Fin",
	globalSearchPreviewInfo: "Info",
	globalSearchPreviewIp: "IP",
	globalSearchPreviewLocation: "Ubicación",
	globalSearchPreviewMac: "MAC",
	globalSearchPreviewNumber: "Número",
	globalSearchPreviewOrderNumber: "Pedido n.º",
	globalSearchPreviewPhone: "Teléfono",
	globalSearchPreviewSent: "Enviado",
	globalSearchPreviewStart: "Inicio",
	globalSearchPreviewUsername: "Usuario",
	globalSearchPreviewVendor: "Proveedor",
	globalSearchPreviewVersion: "Versión",
	globalSearchRecentSearches: "Búsquedas recientes",
	globalSearchRecentlyOpened: "Abiertos recientemente",
	globalSearchSectionArtists: "Artistas",
	globalSearchSectionAttendanceDevices: "Dispositivos de asistencia",
	globalSearchSectionBrands: "Marcas",
	globalSearchSectionCalendarEvents: "Eventos del calendario",
	globalSearchSectionCameras: "Cámaras",
	globalSearchSectionChats: "Chats",
	globalSearchSectionClientGroups: "Grupos de clientes",
	globalSearchSectionClients: "Clientes",
	globalSearchSectionCpus: "CPUs",
	globalSearchSectionDepartments: "Departamentos",
	globalSearchSectionEcomCategories: "Categorías",
	globalSearchSectionFinanceCardIssuers: "Emisores de tarjetas",
	globalSearchSectionFinanceCards: "Tarjetas",
	globalSearchSectionFinanceCategories: "Categorías financieras",
	globalSearchSectionFinanceTransactions: "Transacciones",
	globalSearchSectionGpus: "GPUs",
	globalSearchSectionKeyboards: "Teclados",
	globalSearchSectionLaptops: "Portátiles",
	globalSearchSectionMessages: "Mensajes",
	globalSearchSectionMice: "Ratones",
	globalSearchSectionMonitors: "Monitores",
	globalSearchSectionOrders: "Pedidos",
	globalSearchSectionPcs: "PC",
	globalSearchSectionPlaylists: "Listas",
	globalSearchSectionPositions: "Puestos",
	globalSearchSectionPrinters: "Impresoras",
	globalSearchSectionProblems: "Problemas",
	globalSearchSectionProducts: "Productos",
	globalSearchSectionProjects: "Proyectos",
	globalSearchSectionRams: "RAM",
	globalSearchSectionRoms: "Almacenamiento",
	globalSearchSectionRooms: "Salas",
	globalSearchSectionRouters: "Enrutadores",
	globalSearchSectionSmbs: "SMB",
	globalSearchSectionSoftware: "Software",
	globalSearchSectionSwitches: "Conmutadores",
	globalSearchSectionTelephones: "Teléfonos",
	globalSearchSectionTickets: "Tickets",
	globalSearchSectionTodoBoards: "Tableros",
	globalSearchSectionTodoCategories: "Categorías",
	globalSearchSectionTodoTasks: "Tareas",
	globalSearchSectionTracks: "Pistas",
	globalSearchSectionUsers: "Personas",
	globalSearchSectionWarrantyProviders: "Proveedores de garantía",
	globalSearchSelectPreview: "Seleccione un elemento para previsualizar",
	globalSearchShortcutHint: "Ctrl + K",
	globalSearchShowPreview: "Mostrar vista previa",
	globalSearchSubtitle: "Buscar en todos los módulos",
	globalSearchSuggest1: "Buscar tickets asignados a mí",
	globalSearchSuggest2: "Buscar empleado por correo",
	globalSearchSuggest3: "Buscar mensajes del chat",
	globalSearchSuggest4: "Buscar dispositivo por IP",
	globalSearchSuggest5: "Buscar cliente por teléfono",
	globalSearchSuggest6: "Ir a proyectos",
	globalSearchTrySearchingFor: "Pruebe a buscar",
	goBack: "Volver",
	goToMessage: "Ir al mensaje",
	goToUserAttendanceTab: "Usuarios → asistencia",
	goToUserAttendanceTabTooltip: "Abrir este empleado en RR. HH. Usuarios en la pestaña Asistencia",
	gpu: "GPU",
	grossSalary: "Salario bruto",
	group: "Grupo",
	groupChat: "Chat grupal",
	groupChatWritePermissionDescription: "Todos en el chat pueden escribir mensajes",
	groupChats: "Chats de grupo",
	groupName: "Nombre del grupo (opcional)",
	healthInsurance: "Seguro médico",
	healthInsuranceBenefit: "Seguro médico (beneficio)",
	help: "Ayuda",
	hideAllSteps: "Ocultar todos los pasos",
	hideHistory: "Ocultar historial",
	hideProjectDetails: "Ocultar detalles del proyecto",
	hideTableColumnFilters: "Ocultar filtros de columnas",
	hideTimeline: "Ocultar cronología",
	high: "Alto",
	highestSpendingCustomers: "Clientes con mayor gasto",
	highlight: "Resaltar",
	highlightFeature: "Resaltar función",
	history: "Historia",
	historyTable: "Tabla de historial",
	holiday: "Festivo",
	holidayNonWorking: "Festivo / día no laborable",
	hourlyRate: "Tarifa por hora",
	hourlyRateBaseLinked:
		"Actualiza el salario base desde la tarifa × horas regulares (si horas > 0).",
	hr2025RateReferenceTables: "Tablas de referencia de tipos 2025",
	hrAccrualAnnualTotal: "Total anual: {amount} días",
	hrAccrualCoeffPreview: "Vista previa del coeficiente",
	hrAccrualCoeffPreviewLine1:
		"{accrualWorkedHours} horas trabajadas → {accrualVacationHours} horas de vacaciones",
	hrAccrualCoeffPreviewLine2:
		"Horas de vacaciones obtenidas por hora trabajada: {hourlyCoefficient}",
	hrAccrualCoeffStoredNote:
		"El servidor almacena este devengo en minutos para que la nómina y los saldos de vacaciones puedan usar valores de días parciales sin desviaciones de redondeo.",
	hrAccrualDaily: "Diario (÷ 365)",
	hrAccrualEachDay: "Cada día: +{amount} días de vacaciones",
	hrAccrualEachMonthFirst: "Cada día 1: +{amount} días de vacaciones",
	hrAccrualFixedYearly: "Días de vacaciones anuales fijos",
	hrAccrualFixedYearlyDesc:
		"Devenga un número configurado de días de vacaciones a lo largo del año usando el calendario diario o mensual existente.",
	hrAccrualMethod: "Método de devengo",
	hrAccrualMethodDesc: "Cómo se acumulan las vacaciones",
	hrAccrualModelChoice:
		"Seleccione un modelo de devengo activo. Los días anuales y el coeficiente de horas trabajadas son alternativas, no se combinan.",
	hrAccrualMonthly: "Mensual (÷ 12, el día 1)",
	hrAccrualMonthlyEquivalent: "Equivalente mensual: ~{amount} días",
	hrAccrualPreview: "Vista previa del devengo",
	hrAccrualSuffixMin: "min",
	hrAccrualVacationMinutesEarned: "Minutos de vacaciones obtenidos",
	hrAccrualVacationMinutesEarnedDesc:
		"Cuántos minutos de vacaciones se devengan por cada unidad de tiempo trabajado.",
	hrAccrualWorkedHoursModel: "Horas trabajadas por horas de vacaciones",
	hrAccrualWorkedHoursModelDesc:
		"Devenga vacaciones a partir del tiempo trabajado real usando un coeficiente de horas trabajadas configurable.",
	hrAccrualWorkedMinutesUnit: "Unidad de minutos trabajados",
	hrAccrualWorkedMinutesUnitDesc:
		"Cuántos minutos trabajados deben generar una unidad de devengo.",
	hrArmeniaIncomeTaxCalculator: "Calculadora del IRPF (Armenia)",
	hrArmeniaTaxRates: "Tipos impositivos de Armenia",
	hrCalcSummaryGrossToNet:
		"Con un salario registrado de {gross} AMD, recibirá {net} AMD netos tras deducir {deductions} AMD en impuestos y cotizaciones.",
	hrCalcSummaryNetToGross:
		"Para recibir {net} AMD netos, el contrato debe mostrar un bruto de {gross} AMD.",
	hrCalculationBreakdown: "Desglose del cálculo",
	hrCalculationDirection: "Dirección del cálculo",
	hrDefaultBenefitsDescription:
		"Estos valores predeterminados se aplican a todos los cálculos de nómina salvo que se sustituyan por empleado.",
	hrDefaultMonthlyBenefits: "Beneficios mensuales predeterminados (AMD)",
	hrDesiredNetSalaryLabel: "Salario neto deseado (a percibir)",
	hrEmployeePensionLabel: "Pensión del empleado:",
	hrEmployeePensionRate: "Tipo de pensión del empleado",
	hrEmployeePensionRateDesc: "Obligatorio para nacidos después de 1973 (2,5%)",
	hrEmployerPensionRate: "Tipo de pensión del empleador",
	hrEmployerPensionRateDesc: "Cotización a la pensión del empleador (2,5%)",
	hrFailedToSaveSettings: "No se pudieron guardar los ajustes",
	hrGrossSalaryAMD: "Salario bruto (AMD)",
	hrGrossSalaryDescription: "Introduzca el importe del contrato laboral",
	hrGrossSalaryLabel: "Salario bruto (registrado / contrato)",
	hrGrossSalaryRegistered: "Salario bruto (registrado)",
	hrGrossToNet: "Bruto → Neto",
	hrHealthInsuranceAges: "Seguro médico (18–65 años)",
	hrHealthInsuranceBenefit: "Seguro médico",
	hrHealthInsuranceBenefitDesc: "Cotización mensual del empleador al seguro médico (AMD)",
	hrHealthInsuranceEmployeeColumn: "Empleado",
	hrHealthInsuranceEmployeeShare: "Seguro médico (parte del empleado)",
	hrHealthInsuranceStateColumn: "Estado",
	hrITSector: "Sector TI (IR 10%)",
	hrITSectorDesc: "Empleado de empresa TI licenciada",
	hrIncomeTax: "Impuesto sobre la renta",
	hrIncomeTaxLabel: "Impuesto sobre la renta:",
	hrIncomeTaxRate: "Tipo del IRPF",
	hrIncomeTaxRateDesc: "Tipo fijo del 20% en Armenia desde 2020",
	hrLeaveAccrualConfiguration: "Configuración del devengo de vacaciones",
	hrLiveRates: "Tipos vigentes",
	hrLunchCoverage: "Comida",
	hrLunchCoverageDesc: "Subsidio de comida mensual (AMD)",
	hrMandatoryHealthInsurance: "Seguro médico obligatorio (18–65)",
	hrMandatoryHealthInsuranceDesc: "Incluir tramos de seguro médico 2025",
	hrMilitaryStampRate: "Tipo del impuesto militar",
	hrMilitaryStampRateDesc: "Deje 0 si no aplica",
	hrMonthlyFee: "Cuota mensual",
	hrNetSalaryDescription: "Indique cuánto desea recibir neto",
	hrNetSalaryLabel: "Salario neto:",
	hrNetSalaryTakeHome: "Salario neto (a percibir)",
	hrNetToGross: "Neto → Bruto",
	hrOvertimeRateMultiplier: "Multiplicador de horas extra",
	hrOvertimeRateMultiplierDesc: "p. ej. 1,5× significa un 50 % de prima por horas extra",
	hrOvertimeRules: "Reglas de horas extra",
	hrBreakIntervals: "Descansos",
	hrBreakIntervalsDesc:
		"Franjas horarias fijas diarias (p. ej. almuerzo) excluidas del tiempo de trabajo para todos. Puede añadir varias.",
	hrBreakIntervalsEmpty: "No hay descansos configurados",
	hrBreakIntervalStart: "Inicio del descanso",
	hrBreakIntervalEnd: "Fin del descanso",
	hrAddBreakInterval: "Añadir descanso",
	hrOvertimeThreshold: "Umbral de horas extra (horas/día)",
	hrOvertimeThresholdDesc: "Las horas por encima se pagan a tasa de horas extra",
	hrPensionMandatory: "Obligatoria / voluntaria pre-07/2018 (5%)",
	hrPensionNone: "No participante (0%)",
	hrPensionPost2018: "Voluntaria posterior a 07/2018 (5%)",
	hrPensionSystem: "Régimen de pensiones",
	hrPensionSystemDesc: "Su situación en el sistema de pensiones capitalizado",
	hrSettingsPageSubtitle: "Configure nómina, vacaciones y reglas de asistencia",
	hrSettingsPageTitle: "Configuración de RR. HH.",
	hrSettingsUpdatedSuccessfully: "Configuración de RR. HH. actualizada correctamente",
	hrSickDaysPerYear: "Días de baja por enfermedad al año",
	hrSickDaysPerYearDesc: "Días de baja por enfermedad remunerados por año natural",
	hrSocialPaymentPension: "Pago social (pensión)",
	hrSocialTaxRate: "Tipo del impuesto social",
	hrSocialTaxRateDesc: "Actualmente 0% en Armenia (sustituido por la pensión)",
	hrStampFee: "Tasa (fondo de seguro militar)",
	hrStampFeeTooltip: "Fondo de seguro militar — cuota fija escalonada por tramo de bruto",
	hrStandardWorkSchedule: "Horario de trabajo estándar",
	hrStateHealthContribution: "Aportación estatal a la salud",
	hrStateHealthContributionNote:
		"aportada por el Estado a su cobertura (no se descuenta del salario).",
	hrSuffixDays: "días",
	hrSuffixHours: "h",
	hrSuffixTimes: "×",
	hrSummary: "Resumen",
	hrTabDefaultBenefits: "Beneficios predeterminados",
	hrTabLeaveAccrual: "Devengo de vacaciones",
	hrTabTaxCalculator: "Calculadora fiscal",
	hrTabTaxesArmenia: "Impuestos (Armenia)",
	hrTabWorkSchedule: "Horario de trabajo",
	hrTaxPreviewTitle: "Vista previa fiscal (sobre 500 000 AMD brutos)",
	hrTaxRatesDescription:
		"Las tasas se aplican al salario bruto. Introduzca porcentajes (p. ej. 20 = 20%).",
	hrTaxRatesDisclaimer:
		"Tipos según la legislación armenia 2025–2026. IR: 20 % estándar, 10 % para empresas TI licenciadas. Pensión: 5 % (obligatoria/voluntaria pre-2018) o 5 % fijo (voluntaria post-2018). El 10 % extra aplica a obligatorios/pre-2018 por encima de 500 000 AMD. Consulte a un contador.",
	hrThresholdWarning: "Aviso de umbral",
	hrThresholdWarningText:
		"Su salario está cerca de un umbral de tramo (100k / 200k / 500k / 1M AMD). Ahí suben tasa y seguro: un pequeño aumento del bruto puede bajar el neto. La calculadora muestra siempre el bruto mínimo para el neto pedido.",
	hrTickets: "Tickets RRHH",
	hrTotalDeductions: "Total deducciones",
	hrTotalEmployeeDeductionsLabel: "Total deducciones del empleado:",
	hrTransportAllowance: "Subsidio de transporte",
	hrTransportAllowanceDesc: "Beneficio de transporte mensual (AMD)",
	hrVacationDaysPerYear: "Días de vacaciones al año",
	hrVacationDaysPerYearDesc: "Derecho anual completo (mínimo en Armenia: 20)",
	hrWorkingDayEnd: "Fin de la jornada laboral",
	hrWorkingDayEndDesc: "Fin esperada del turno. Las horas diarias se calculan desde inicio/fin",
	hrWorkingDayStart: "Inicio de la jornada laboral",
	hrWorkingDayStartDesc: "Hora esperada de entrada para asistencia y tardanzas",
	hrWeekendDays: "Días de fin de semana",
	hrWeekendDaysDesc: "Selecciona qué días de la semana son fines de semana no laborables",
	hrWorkingDaysPerWeek: "Días laborables por semana",
	hrWorkingDaysPerWeekDesc: "Lun–Vie = 5, Lun–Sáb = 6",
	hrWorkingHoursPerDay: "Horas de trabajo por día",
	hrWorkingHoursPerDayDesc: "Horas estándar antes de las horas extra",
	href: "Enlace",
	humanResources: "Recursos humanos",
	id: "ID",
	idCard: "Tarjeta de identificación",
	idCardEndDate: "Fecha de finalización de la tarjeta de identificación",
	idCardNo: "Nº de tarjeta de identificación",
	idCardStartDate: "Fecha de inicio de la tarjeta de identificación",
	idCart: "Tarjeta de identificación",
	image: "Imagen",
	immediateSupervisor: "Supervisor inmediato",
	importance: "Importancia",
	important: "Importante",
	inProgress: "En progreso",
	inSelectedPeriod: "en el período seleccionado",
	inStock: "En stock",
	in_progress: "En progreso",
	inactive: "Inactivo",
	inactiveTime: "Tiempo inactivo",
	incident: "Incidente",
	incomeTaxAmount: "Importe del IRPF",
	incomeTaxRate: "Tipo del IR (%)",
	incomingCall: "Llamada entrante",
	incomingVideoCall: "Llamada de video entrante",
	incorrectLogin: "Ingresó un nombre de usuario o una contraseña incorrectos",
	index: "#",
	inputInArmenian: "Introducir en armenio",
	inputInLatin: "Introducir en latín",
	inputInNumbers: "Entrada en números",
	inputInRussian: "Introducir en ruso",
	inputNumber: "Introducir número",
	inputNumbers: "Ingrese números",
	instagramPosts: "Publicaciones de Instagram",
	insufficientVacationBalance: "Saldo de vacaciones insuficiente",
	interview1: "Entrevista",
	interview2: "Entrevista",
	interview3: "Entrenamiento",
	interview4: "Pasantía",
	interviewDate: "Fecha de la entrevista",
	interviewTime: "Hora de la entrevista",
	introSection: "Sección de introducción",
	invalidDate: "Fecha de entrega inválida",
	inventorySummary: "Resumen de inventario",
	ip: "IP",
	ipAddress: "Dirección IP",
	isActive: "Activo",
	isColor: "Color",
	isPrivateOffice: "¿Es un despacho privado?",
	isPublic: "Público",
	itTickets: "Tickets IT",
	items: "elementos",
	justifiedAbsence: "Ausencia justificada",
	keyText: "Texto clave",
	keyboards: "Teclados",
	label: "Etiqueta",
	language: "Idioma",
	languagePickerLabel: "Idioma",
	large: "Grande",
	last7Days: "conectados en los últimos 7 días",
	lastAction: "Última acción",
	lastLogin: "Último inicio de sesión",
	lastName: "Apellido",
	lastOut: "Última salida",
	lastPunch: "Ultimo marcaje",
	lasts: "Duración",
	latestCustomerOrders: "Últimos pedidos de clientes",
	leader: "Líder",
	attendanceManagersFilter: "Gerentes",
	attendanceLeadersFilter: "Líderes",
	leaveBalance: "Saldo de permisos",
	linkCopied: "Enlace copiado",
	listeners: "Oyentes",
	livingAddress: "Dirección de residencia",
	loading: "Cargando",
	loanDeductions: "Deducciones de préstamo",
	localCode: "Código local",
	logOut: "Cerrar sesión",
	login: "Iniciar sesión",
	loginButton: "Iniciar sesión",
	loginFailed: "Inicio de sesión fallido",
	loginFailedMessage: "Por favor, verifique sus credenciales de inicio de sesión",
	loginSuccess: "Inicio de sesión exitoso",
	loginSuccessMessage: "Has iniciado sesión con éxito",
	loginToStartSession: "Inicie sesión para comenzar una sesión",
	logout: "Cerrar sesión",
	low: "Bajo",
	lunchCoverage: "Comida",
	mac: "MAC",
	macAddress: "Dirección MAC",
	main: "Principal",
	itHierarchyAddLaptop: "Añadir portátil",
	itHierarchyAttachedPc: "PC conectado",
	itHierarchyLaptopsUsingPart: "Portátiles que usan esta pieza",
	itUsedInOtherPlaces: "Utilizado en otros lugares",
	mainInformation: "Información básica",
	mainInfo: "Información principal",
	contactInfo: "Información de contacto",
	personalInfo: "Información personal",
	workingInfo: "Información laboral",
	probation: "Período de prueba",
	educationInfo: "Información educativa",
	male: "Hombre",
	manualAdjustments: "Ajustes manuales",
	manualAttendanceEntry: "Entrada manual",
	maps: "Mapas",
	maritalStatus: "Estado civil",
	markAllAsRead: "Marcar todo como leído",
	markSelectedAsRead: "Marcar selección como leída",
	maternityLeave: "Maternidad",
	maxEnergy: "Energía máxima",
	maxFilesReached: "Número máximo de archivos alcanzado",
	maxSize: "Tamaño máximo",
	mediaGallery: "Galería de medios",
	mediaGalleryDescription: "Descripción de la galería de medios",
	mediator: "Mediador",
	medium: "Medio",
	members: "Miembros",
	menu: "Menú",
	message: "Mensaje",
	messages: "Mensajes",
	messagesByType: "Mensajes por tipo",
	messagesOverTime: "Mensajes a lo largo del tiempo (Últimos 30 días)",
	militaryStampAmount: "Importe del impuesto militar",
	militaryStampRate: "Tipo del impuesto militar",
	minEnergy: "Energía mínima",
	minute: "minuto",
	minutes: "Minutos",
	missingInterval: "Intervalo faltante",
	mon: "Lunes",
	monitor: "Monitor",
	monitors: "Monitores",
	month: "Mes",
	monthly: "Mensual",
	mood: "Estado de ánimo",
	more: "Adicional",
	moreDetailed: "Más detallado",
	moreThan: "Más de",
	motherProject: "Proyecto madre",
	mounted: "Montado",
	mouses: "Ratones",
	moveToTrash: "Mover a la papelera",
	movedToTrash: "Movido a la papelera",
	myActiveSteps: "Mis pasos activos",
	myInvolvement: "Mi participación",
	myProjects: "Mis proyectos",
	myRole: "Mi papel",
	mySteps: "Mis pasos",
	myTickets: "Mis tickets",
	na: "N/A",
	name: "Nombre",
	netCash: "Neto en efectivo",
	netOfficial: "Neto oficial",
	netSalary: "Salario net",
	newClients: "Nuevos clientes",
	newClientsOverTime: "Nuevos clientes a lo largo del tiempo (últimos 30 días)",
	newMessage: "Nuevo mensaje",
	newProducts: "Productos nuevos",
	newProject: "Nuevo proyecto",
	newProjects: "Nuevos proyectos",
	newThisPeriod: "Nuevo este período",
	newTicket: "Nuevo ticket",
	newTicketCreatedBy: "Nuevo ticket creado por",
	newTracks: "Nuevas pistas",
	newTracksOverTime: "Nuevas pistas a lo largo del tiempo (últimos 30 días)",
	next: "Siguiente",
	nextComposition: "Próxima composición",
	nextStep: "Próximo paso",
	noAccess: "Sin acceso",
	noActiveSteps: "No hay pasos activos",
	noBoardsFound: "Tableros no encontrados",
	noCategoriesFound: "Categorías no encontradas",
	noCategoryDataAvailable: "No hay datos de categoría disponibles",
	noContent: "No hay contenido",
	noCustomerDataAvailable: "No hay datos de clientes disponibles",
	noData: "No hay datos disponibles",
	noDataAvailable: "No hay datos disponibles",
	noDataAvailableForSelectedPeriod: "No hay datos disponibles para el período seleccionado",
	noDepartment: "Sin departamento",
	noDepartments: "No hay departamentos",
	noDescription: "Descripción no encontrada",
	noEmail: "Sin correo electrónico",
	noExpiringIdCards: "No hay tarjetas de identificación que estén por vencer",
	noExpiringPassports: "No hay pasaportes que estén por vencer",
	noGroup: "Sin grupo",
	noMediaDescription: "Descripción de media no encontrada",
	noMediaFound: "No se encontró media",
	noMoreItems: "No hay más elementos",
	noName: "Sin nombre",
	noNeedStep45: "No se necesitan los pasos 4-5",
	noNotifications: "Sin notificaciones",
	noOrdersInSelectedPeriod: "No hay pedidos en el período seleccionado",
	noOvertimeRecords: "No se encontraron registros de horas extra",
	noPaymentDataAvailable: "No hay datos de pago disponibles",
	noProjectsAssigned: "No hay proyectos asignados",
	noProjectsAssignedOrInvolved: "No hay proyectos asignados o involucrados",
	noRecentContacts: "No hay clientes recientes",
	noRecentContent: "No hay contenido reciente",
	noRecentTickets: "No hay billetes recientes",
	noRecentTracks: "No hay pistas recientes",
	noRecipientInformation: "Sin información del destinatario",
	noResponsible: "Sin responsable",
	noResult: "No se encontraron resultados",
	noResults: "No se encontraron resultados",
	noResultsFound: "No se encontraron resultados",
	noRulesAdded: "Reglas de planificación no añadidas",
	noStatusData: "No hay datos de estado disponibles",
	noSystemDaysOffThisMonth: "No hay días libres globales este mes",
	noTaskDataAvailable: "No hay datos de tarea disponibles",
	noTasksYet: "No hay tareas",
	noTasksYetDescription: "No hay tareas",
	noUpcomingBirthdays: "No hay cumpleaños próximos",
	noUsersFound: "No se encontraron usuarios",
	noUsersInDepartment: "No hay usuarios en este departamento",
	noWorkHourData: "No hay datos de horas de trabajo",
	no_priority: "Sin prioridad",
	nonWorking: "Día no laborable",
	none: "Ninguno",
	notAvailable: "Producto no disponible",
	notCorrectLoginCredentials: "Credenciales de inicio de sesión incorrectas",
	notLoggedInToday: "No ha iniciado sesión hoy",
	notPlaced: "No colocado",
	notPresent: "No Presente",
	notResponded: "Sin respuesta",
	notWorking: "No funciona",
	deviceProblems: "Problemas de dispositivos",
	openTickets: "Tickets abiertos",
	note: "Nota",
	nothingFound: "No se encontró nada",
	notifications: "Notificaciones",
	notificationsBellAria: "Abrir notificaciones",
	similarTicketNotifications: "Notificaciones de billetes similares",
	number: "Número",
	"office-map": "Mapa de la oficina",
	officeMapActivatePlacement: "Activar colocación",
	officeMapAgent: "Agente",
	officeMapAll: "Todo",
	officeMapAttendanceDevice: "Dispositivo de asistencia",
	officeMapAttendanceDevices: "Asistencia",
	officeMapCable: "Cable",
	officeMapCableLinePlaced: "La línea de cable fue colocada",
	officeMapCableRemovedFromMap: "El cable fue quitado del mapa",
	officeMapCables: "Cables",
	officeMapCamera: "Cámara",
	officeMapCameras: "Cámaras",
	officeMapNvr: "NVR",
	officeMapChat: "Chat",
	officeMapChatWasNotCreated: "El chat no fue creado",
	officeMapConnectToCamera: "Conectar a la cámara",
	officeMapCpu: "CPU",
	officeMapDeactivate: "Desactivar",
	officeMapDeviceDetails: "Detalles del dispositivo",
	officeMapDeviceId: "ID del dispositivo",
	officeMapDisableDragging: "Desactivar arrastre",
	officeMapEnableDragging: "Activar arrastre",
	officeMapEndDeviceOptional: "Dispositivo final (opcional)",
	officeMapFailedToMoveCable: "No se pudo mover el cable",
	officeMapFailedToMoveItem: "No se pudo mover el elemento",
	officeMapFailedToMoveRoomArea: "No se pudo mover el área de la sala",
	officeMapFailedToOpenChat: "No se pudo abrir el chat",
	officeMapFailedToPlaceItem: "No se pudo colocar el elemento",
	officeMapFailedToPlaceUser: "No se pudo colocar el usuario",
	officeMapFailedToRemoveCable: "No se pudo quitar el cable",
	officeMapFailedToRemoveItem: "No se pudo quitar el elemento",
	officeMapFailedToRemoveRoomArea: "No se pudo quitar el área de la sala",
	officeMapFailedToSaveCableLine: "No se pudo guardar la línea de cable",
	officeMapFailedToSaveRoomArea: "No se pudo guardar el área de la sala",
	officeMapFinishArea: "Finalizar área",
	officeMapFinishCable: "Finalizar cable",
	officeMapForbidden: "Prohibido",
	officeMapIp: "IP",
	officeMapItem: "Elemento",
	officeMapItemPlaced: "Elemento colocado",
	officeMapItemRemovedFromMap: "El elemento fue quitado del mapa",
	officeMapLaptop: "Portátil",
	officeMapLaptops: "Portátiles",
	officeMapLayers: "Capas",
	officeMapLinkedItRoom: "Sala IT vinculada",
	officeMapLive: "En vivo",
	officeMapMac: "MAC",
	officeMapMin: "mín.",
	officeMapMonitors: "Monitores",
	officeMapNetworkCable: "Cable de red",
	officeMapNoDevicesInArea: "No hay dispositivos ni usuarios ubicados en esta área.",
	officeMapNoPermissionToPlaceItem: "No tiene permiso para colocar este elemento.",
	officeMapNoPermissionToPlaceNetworkCable: "No tiene permiso para colocar un cable de red.",
	officeMapNoPermissionToPlaceRoomArea: "No tiene permiso para colocar un área de sala.",
	officeMapNoPermissionToRemoveItem: "No tiene permiso para quitar este elemento del mapa.",
	officeMapNoPermissionToRemoveNetworkCable:
		"No tiene permiso para quitar el cable de red del mapa.",
	officeMapNoPermissionToRemoveRoomArea:
		"No tiene permiso para quitar el área de la sala del mapa.",
	officeMapNotAvailable: "N/D",
	officeMapNotConnected: "No conectado",
	officeMapPc: "PC",
	officeMapPcs: "PC",
	officeMapPlacement: "Ubicación",
	officeMapPleaseSelectItemFirst: "Primero seleccione un elemento",
	officeMapPleaseSelectRoomFirst: "Primero seleccione una sala",
	officeMapPoints: "Puntos",
	officeMapPorts: "Puertos",
	officeMapPrinted: "Impreso",
	officeMapPrinters: "Impresoras",
	officeMapRam: "RAM",
	officeMapRemoveFromMap: "Quitar del mapa",
	officeMapRom: "ROM",
	officeMapRoomArea: "Área de sala",
	officeMapRoomAreaPlaced: "El área de la sala fue colocada",
	officeMapRoomAreaRemovedFromMap: "El área de la sala fue quitada del mapa",
	officeMapRoomAreas: "Salas",
	officeMapRoomContents: "Contenido de la sala",
	officeMapRouter: "Router",
	officeMapRouters: "Routers",
	officeMapSelectItem: "Seleccionar elemento",
	officeMapSelectRoom: "Seleccionar sala",
	officeMapSpeed: "Velocidad",
	officeMapStartDeviceOptional: "Dispositivo inicial (opcional)",
	officeMapSwitches: "Switches",
	officeMapTelephone: "Teléfono",
	officeMapTelephones: "Teléfonos",
	officeMapUnknown: "Desconocido",
	officeMapUrl: "URL",
	officeMapUserPlacedOnMap: "El usuario fue colocado en el mapa",
	officeMapUsers: "Usuarios",
	officeMapViewContents: "Ver contenido",
	officeMapViewFullDetails: "Ver detalles completos",
	offline: "Sin conexión",
	offlinePaymentOnly: "Solo pago sin conexión",
	oldProject: "Proyecto antiguo",
	onSale: "En venta",
	onSecond: "En segundo",
	onTime: "A tiempo",
	onTimeRate: "Tasa de puntualidad",
	oneOf: "Uno de",
	open: "Abrir",
	openBoard: "Abrir Board",
	openDate: "Fecha de apertura",
	openInModal: "Abrir en ventana modal",
	openInNewTab: "Abrir en una nueva pestaña",
	openNavigation: "Abrir navegación",
	openedDate: "Fecha de apertura",
	optional: "Opcional",
	orClickToSelect: "o haz clic para seleccionar archivos",
	order: "Orden",
	orderNumber: "Número de orden",
	orders: "Pedidos",
	ordersCart: "Gráfico de pedidos",
	otAfterWork: "Horas extra después del trabajo",
	otBeforeWork: "Horas extra antes del trabajo",
	otherBenefits: "Otros beneficios",
	otherDeductions: "Otras deducciones",
	otherInsurance: "Otro seguro",
	outOfStock: "Agotado",
	overdue: "Vencido",
	overtimeComment: "Comentario horas extra",
	overtimeDays: "Días con horas extra",
	overtimeHours: "Horas extra",
	overtimeRate: "Tasa de horas extra",
	overtimeSummary: "Resumen de horas extra",
	overtimeTotal: "Total horas extra",
	overview: "Resumen",
	owner: "Propietario",
	ownership: "Propiedad",
	pageNotFound: "Página no encontrada",
	pageNotFoundDescription:
		"¡Ups! La página que buscas no existe o ha sido movida. Es posible que haya sido eliminada, haya cambiado de nombre o no esté disponible temporalmente.",
	pages: "Páginas",
	paid: "Pagado",
	paidStatus: "Estado de pago",
	paidTimeOff: "Permiso retribuido",
	paidTimeOffDays: "Días de permiso retribuido",
	parent: "Padre",
	parentCategory: "Categoría principal",
	parentDepartment: "Departamento padre",
	parentTask: "Tarea principal",
	parentType: "Tipo de padre",
	parentUser: "Usuario padre",
	participant: "Participante",
	passportEndDate: "Fecha de vencimiento del pasaporte",
	passportImages: "Imágenes de pasaporte",
	passportNo: "Nº de pasaporte",
	passportStartDate: "Fecha de inicio del pasaporte",
	password: "Contraseña",
	pause: "Pausa",
	paused: "En pausa",
	payDate: "Fecha de pago",
	paymentMethod: "Método de pago",
	paymentMethods: "Métodos de pago",
	paymentSystem: "Sistema de pago",
	payrollBreakdown: "Desglose de nómina",
	payrollCalcError: "Falló el cálculo de nómina.",
	payrollCalcHint:
		"Empleado y período son obligatorios. Haz clic para calcular y guardar los totales de nómina.",
	payrollCalcMissingFields: "Selecciona empleado, inicio y fin del período.",
	payrollCommentsForEmployee: "Comentarios para el empleado",
	payrollGeneratedFromAttendance: "Nómina generada desde asistencia",
	payrollHealthInsurancePremium: "Seguro médico (prima)",
	payrollIndexLabel: "N.º",
	payrollIndexPlaceholder: "Índice",
	payrollInternalNotes: "Notas internas",
	payrollNotesSection: "Notas",
	payrollType: "Tipo de nómina",
	payrollUsesHrSettings:
		"Horas extra, tipos impositivos y beneficios predeterminados (comida, transporte, salud) siguen la configuración de RR. HH. (Sistema → Ajustes de RR. HH.).",
	pc: "Computadora",
	pcHealth: "Estado del PC",
	pcs: "PCs",
	pdf: "PDF",
	penalties: "Penalizaciones",
	pending: "Pendiente",
	pensionAmount: "Importe de pensión",
	pensionRate: "Tipo de pensión",
	periodEnd: "Fecha de fin",
	periodStart: "Fecha de inicio",
	permInput_calendarEvent_overlayCustomCalendars: "Calendarios personalizados (filtros)",
	permInput_calendarEvent_overlayIt: "Calendarios TI (garantía PC)",
	permInput_calendarEvent_overlayPeople: "Calendarios de personas (RR. HH.)",
	permInput_calendarEvent_overlayReminders: "Capa de recordatorios",
	permInput_calendarEvent_overlayTasks: "Tareas (capas de prioridad)",
	permInput_calendarEvent_overlayTickets: "Capa de tickets (fechas limite por dominio)",
	permInput_chat_attachFile: "Adjuntar archivos",
	permInput_chat_calling: "Llamadas de audio",
	permInput_chat_pin: "Fijar mensajes",
	permInput_chat_searchFiles: "Buscar en archivos",
	permInput_chat_searchMessages: "Buscar en mensajes",
	permInput_chat_sendMessage: "Enviar mensajes",
	permInput_chat_star: "Marcar mensajes con estrella",
	permInput_chat_videoCalling: "Llamadas de video",
	permModuleCrud_download: "Descarga de calendario (importar .ics)",
	permModuleCrud_upload: "Subida de calendario (exportar .ics)",
	permanentDelete: "¿Eliminar permanentemente?",
	permission: "Permiso",
	permissions: "Permisos",
	persons: "Personas",
	phone: "Teléfono",
	photo: "Foto",
	photos: "Fotos",
	pickEmoji: "Elige un emoji",
	pinnedMessages: "Mensajes fijados",
	placed: "Colocado",
	placedState: "Estado colocado",
	placeholder: "Marcador de posición",
	platformDashboard: "Panel de control de la plataforma",
	platformSpecificSettings: "Configuración específica de la plataforma",
	platforms: "Plataformas",
	audioPlaybackSpeed: "Velocidad de reproducción: {rate}. Pulsa para cambiar.",
	playbackMute: "Silenciar",
	playbackUnmute: "Activar sonido",
	playbackVoiceMessage: "Mensaje de voz",
	playbackVideoMessage: "Mensaje de vídeo",
	previewVoiceMessage: "Vista previa del mensaje de voz",
	play: "Reproducir",
	playStatus: "Estado de reproducción",
	playing: "Reproduciendo",
	playingComposition: "Composición en reproducción",
	playingHistory: "Historial de reproducción",
	playlist: "Lista de reproducción",
	playlistStatistics: "Estadísticas de listas de reproducción",
	playlistsWithAds: "listas de reproducción con anuncios",
	playlistsWithoutAds: "listas de reproducción sin anuncios",
	podcast: "Podcast",
	podcastStreams: "transmisiones de podcasts",
	podcasts: "Podcasts",
	ports: "Puertos",
	position: "Posición",
	positionReviewDate: "Fecha de revisión del puesto",
	preDefinedFilters: "Filtros predefinidos",
	preview: "Vista previa",
	previous: "Anterior",
	previousStep: "Paso anterior",
	price: "Precio",
	priceB2b: "Precio corporativo",
	priceBasic: "Precio básico",
	priceGroup1: "Grupo de precios 1",
	priceGroup2: "Grupo de precios 2",
	priceGroup3: "Grupo de precios 3",
	priceLists: "Listas de precios",
	printedCount: "Conteo impreso",
	printer: "Impresora",
	printers: "Impresoras",
	priority: "Prioridad",
	priorityDescription: "Reglas de planificación",
	private: "Privado",
	privateChat: "Chat privado",
	privateChatDescription: "Solo los usuarios seleccionados pueden ver y unirse a este chat",
	problem: "Problema",
	problemDescription: "Descripción del problema",
	problemGroup: "Grupo de problemas",
	problemGroupSupervisorsPlaceholder:
		"Usuarios responsables de gestionar los tickets en este grupo de problemas",
	problemGroupSupervisorsTab: "Supervisores",
	processTime: "Tiempo de proceso",
	processing: "Procesando",
	progress: "Progreso",
	product: "Producto",
	productCare: "Cuidado del producto",
	products: "Productos",
	productsLinked: "Productos vinculados",
	project: "Proyecto",
	projectChanges: "Cambios del proyecto",
	projectDeadline: "Fecha límite del proyecto",
	projectDetails: "Detalles del proyecto",
	projectEndDate: "Fecha de finalización del proyecto",
	projectID: "ID del proyecto",
	projectPartition: "Partición del proyecto",
	projectPrice: "Precio del proyecto",
	projectPrice2: "Precio del proyecto",
	projectStartDate: "Fecha de inicio del proyecto",
	projectType: "Tipo de proyecto",
	projectTypes: "Tipos de proyectos",
	projects: "Proyectos",
	promoCode: "Código promocional",
	promoCodes: "Códigos promocionales",
	promoCodesAndCertificates: "Códigos promocionales y certificados",
	promotions: "Promociones",
	propertyNumber: "Número de propiedad",
	providing: "Proporcionar",
	punchActivity: "Actividad de fichajes",
	pto: "Días pagados",
	partial: "Parcial",
	quantity: "Cantidad",
	radioDashboard: "Panel de radio",
	radioManagementOverview: "Resumen de la gestión de transmisión de radio",
	radioStatistics: "Estadísticas de radio",
	raises: "Aumentos",
	ram: "RAM",
	rate: "Tasa",
	rating: "Puntuación",
	readOnly: "Solo lectura",
	readOnlyChatNotice:
		"Este chat es de solo lectura para los miembros. Solo los administradores pueden escribir mensajes.",
	readyToGetStarted: "Listo para comenzar",
	recalculatePayroll: "Recalcular nómina",
	recentClients: "Clientes recientes",
	recentContent: "Contenido reciente",
	recentMessages: "Mensajes recientes",
	recentOrders: "Pedidos recientes",
	recentTickets: "Billetes recientes",
	recentTracks: "Pistas recientes",
	refresh: "Actualizar",
	registeredAddress: "Dirección registrada",
	regularHours: "Horas regulares",
	regularHoursHrScheduleHint:
		"Autorrelleno desde RR. HH.: días laborables en el período × horas por día. Editable.",
	regularPlaylists: "Listas de reproducción regulares",
	relatedList: "Lista relacionada",
	relatedObjects: "Objetos relacionados",
	relatedProducts: "Productos relacionados",
	relatedTasks: "Tareas relacionadas",
	relations: "Relaciones",
	remainingVacation: "Vacaciones restantes",
	remote: "Remoto",
	remoteWorkDays: "Días de teletrabajo",
	remove: "Eliminar",
	removeFromList: "Eliminar de la lista",
	removeItem: "Eliminar elemento",
	removed: "Eliminado",
	reopen: "Reabrir",
	replaceableProduct: "Producto reemplazable",
	replaceableProducts: "Productos reemplazables",
	replied: "Respondido",
	reply: "Responder",
	request: "Solicitud",
	requestedForUser: "Solicitado para",
	reset: "Restablecer",
	responseTimeDistribution: "Distribución del tiempo de respuesta",
	responsible: "Responsable",
	responsibleAndUsers: "Responsables y usuarios",
	restoreSelected: "Restaurar seleccionados",
	restored: "Restaurado",
	returning: "Recurrente",
	revenue: "Ingresos",
	revenueOverview: "Resumen de ingresos",
	review: "Revisión",
	rightNow: "Ahora mismo",
	role: "Rol",
	rom: "ROM",
	room: "Sala",
	routers: "Enrutadores",
	rpaPrice: "Precio del trabajo del departamento de RPA",
	ruleName: "Nombre de la regla",
	salary: "Salario",
	salaryReviewDate: "Fecha de revisión del salario",
	sale: "Venta",
	salePrice: "Precio de venta",
	salesBreakdownByCategory: "Desglose de ventas por categoría",
	salesPerformanceOverTime: "Rendimiento de ventas a lo largo del tiempo",
	sat: "Sábado",
	save: "Guardar",
	saveChanges: "Guardar cambios",
	saveComment: "Guardar comentario",
	saved: "Guardado",
	schedulingDisabled: "Planificación desactivada",
	schedulingEnabled: "Planificación activada",
	schedulingRules: "Reglas de planificación",
	search: "Buscar",
	searchByNameOrId: "Buscar por nombre o ID…",
	searchChat: "Buscar chat...",
	searchChatGroups: "Buscar grupos de chat...",
	searchConversations: "Buscar conversaciones...",
	searchResults: "Resultados de búsqueda",
	searchUsers: "Buscar usuarios...",
	secondary: "Secundario",
	seconds: "segundos",
	securityAcknowledge: "Reconocer",
	securityActions: "Acciones",
	securityActiveBadge: "Activa",
	securityActiveSessions: "Sesiones activas",
	securityActivityStatClicks: "Clics",
	securityActivityStatKeys: "Teclas",
	securityActivityStatMoves: "Movimientos",
	securityActivityTimeline: "Línea de tiempo de actividad",
	securityAdminNotes: "Notas de admin",
	securityAdminNotesDevice: "Notas internas sobre este dispositivo...",
	securityAgentHeartbeat: "Latido del agente",
	securityAlertClipPlural: "clips por alerta en esta página",
	securityAlertClipSingular: "clip por alerta en esta página",
	securityAlertCount: "alerta",
	securityAlertCountPlural: "alertas",
	securityAlertDrawerNoMedia:
		"Sin medios vinculados. El agente necesita FFmpeg. En Windows PATH o FFMPEG_PATH. Revise registros.",
	securityAlertDrawerVideoFailed:
		"Orden de vídeo enviada sin subida. Posible error del agente — revise los registros.",
	securityAlertDrawerVideoPending:
		"Grabando vídeo; aparecerá en breve. El agente captura y sube ahora.",
	securityAlertRecordings: "Grabaciones de alerta",
	securityAlertRecordingsOnly: "Solo grabaciones de alerta",
	securityAlertSt_acknowledged: "reconocida",
	securityAlertSt_false_positive: "falso positivo",
	securityAlertSt_open: "abierta",
	securityAlertSt_resolved: "resuelta",
	securityAlertsTitle: "Alertas de seguridad",
	securityAllDevices: "Todos los dispositivos",
	securityAllEventTypes: "Todos los tipos",
	securityAllRules: "Todas las reglas",
	securityAllSeverities: "Todas las gravedades",
	securityAllStatuses: "Todos los estados",
	securityAppProcessTracking: "Apps / procesos",
	securityAppTracking: "Apps",
	securityAppUsageToday: "Uso de apps hoy (min)",
	securityAssignedUser: "Usuario asignado",
	securityBadgeAlertText: "ALERTA",
	securityBadgeApp: "app",
	securityBadgeApps: "Apps",
	securityBadgeCapture: "captura",
	securityBadgeFiles: "Archivos",
	securityBadgeOff: "apagado",
	securityBadgeScr: "cap.",
	securityBadgeScreenshot: "Captura",
	securityBadgeVideo: "Vídeo",
	securityBadgeWeb: "Web",
	securityCapture: "Captura",
	securityCaptureEnabledMaster: "Captura activada (maestro)",
	securityCaptureEverySeconds: "Capturar cada (segundos)",
	securityCaptureMasterSwitch: "Captura activada (interruptor maestro)",
	securityCaptureModes: "Modos de captura",
	securityCaptureOffAlertBody:
		"Captura desactivada en el dispositivo; anula la política. Hay alertas pero sin capturas ni vídeo.",
	securityCaptureOffAlertTitle: "Anulación de captura: APAGADO",
	securityCaptureRecorded: "Captura registrada",
	securityCaptureWhenOnDesc: "Si está activo, capturas y vídeo; apagar desactiva ambos",
	securityChartMinutes: "minutos",
	securityChartVisits: "visitas",
	securityClearFilters: "Borrar filtros",
	securityClickLeft: "I",
	securityClickMiddle: "C",
	securityClickPlain: "clic",
	securityClickRight: "D",
	securityClipWord: "Clip",
	securityConnectedDevices: "Dispositivos conectados",
	securityCreated: "Creado",
	securityDeleteDevice: "Eliminar dispositivo",
	securityDeleteDeviceConfirm: "¿Está seguro de que desea eliminar",
	securityDeleteDeviceNote:
		"Esto elimina solo el registro del dispositivo de seguridad. El perfil del PC en IT no se verá afectado.",
	securityDeleteDeviceTitle: "Eliminar dispositivo de seguridad",
	securityDeleteMedia: "Eliminar",
	securityDeletePolicyConfirm: "¿Eliminar esta política?",
	securityDevice: "Dispositivo",
	securityDeviceFallback: "Dispositivo",
	securityDeviceIdLabel: "ID del dispositivo",
	securityDeviceNotFound: "Dispositivo no encontrado",
	securityDeviceSettings: "Ajustes",
	securityDeviceSettingsHint: "Anula la política activa del dispositivo. Hereda si está vacío.",
	securityDevicesBreadcrumb: "Dispositivos",
	securityDevicesTitle: "Dispositivos de seguridad",
	securityDevicesWithAlerts: "Dispositivos con alertas",
	securityDividerCapture: "Captura",
	securityDividerNotes: "Notas",
	securityDividerTracking: "Seguimiento",
	securityDuration: "Duración",
	securityEg15: "p. ej. 15",
	securityEg30: "p. ej. 30",
	securityEg300: "p. ej. 300",
	securityEg5: "p. ej. 5",
	securityEg60: "p. ej. 60",
	securityEnabled: "Activado",
	securityEnd: "Fin",
	securityEventFlushSeconds: "Vaciado de eventos (s)",
	securityEventsCount: "evento",
	securityEventsCountPlural: "eventos",
	securityEvtAppProcess: "App / proceso",
	securityEvtAppUsage: "Uso de app",
	securityEvtFileEvent: "Evento de archivo",
	securityEvtHeartbeat: "Latido",
	securityEvtInputActivity: "Actividad de entrada",
	securityEvtKeystroke: "Pulsación",
	securityEvtMouseClick: "Clic del ratón",
	securityEvtSessionEnd: "Fin de sesión",
	securityEvtSessionStart: "Inicio de sesión",
	securityEvtSystemBoot: "Arranque del sistema",
	securityEvtSystemShutdown: "Apagado del sistema",
	securityEvtUsb: "Evento USB",
	securityEvtUserLogin: "Inicio de sesión",
	securityEvtUserLogout: "Cierre de sesión",
	securityEvtWebVisit: "Visita web",
	securityEvtWorkstationLock: "Pantalla bloqueada",
	securityEvtWorkstationUnlock: "Pantalla desbloqueada",
	securityFailedLoadOverview: "Error al cargar la vista general de seguridad",
	securityFailedSavePolicy: "Error al guardar la política",
	securityFalsePositiveBtn: "Falso positivo",
	securityFileEventTracking: "Eventos de archivos",
	securityFilterByDate: "Filtrar por fecha",
	securityFilterDateRange: "Filtrar por rango de fechas",
	securityFilteredSuffix: "(filtrado)",
	securityFps: "FPS",
	securityHostname: "Nombre de host",
	securityInputActivityCounts: "Actividad de entrada (conteos)",
	securityInputKeystrokeClickTracking: "Seguimiento de teclas/clics",
	securityInputModeActivityCountsShort: "Solo actividad — conteos",
	securityInputModeActivityOnly: "Solo actividad (conteos)",
	securityInputModeDisabled: "Desactivado",
	securityInputModeDisabledShort: "Desactivado — sin métricas",
	securityInputModeEventsOnly: "Solo eventos",
	securityInputModeEventsStream: "Solo eventos — flujo en bruto",
	securityInputModeFullDetail: "Detalle completo (teclas + clics)",
	securityInputModeFullKeystrokes: "Detalle completo — teclas y clics",
	securityInputModeShort: "Modo de entrada",
	securityInputTrackingMode: "Modo de seguimiento de entrada",
	securityInternalNotesPlaceholder: "Notas internas...",
	securityKeyCharPrefix: "tecla:",
	securityLastSeen: "Última vez visto",
	securityLatestClip: "Último clip",
	securityLinkedItPc: "PC de TI vinculado:",
	securityLiveLoadingSub:
		"Conectando con el agente — la vista previa de la pantalla aparecerá en un momento.",
	securityLiveOfflineHint:
		"Dispositivo sin conexión — la vista en vivo requiere un agente conectado.",
	securityLivePressStart: "Pulse Iniciar en vivo para abrir la transmisión.",
	securityLiveScreenAlt: "Pantalla en vivo",
	securityLiveStatusLive: "EN VIVO",
	securityLiveStatusStandby: "En espera",
	securityLiveStreamHint: "Flujo a media resolución, hasta 10 fps. Agente v1.4.0+ con jimp.",
	securityLiveWaitingFrames: "Cargando transmisión en vivo…",
	securityLoggedInSince: "Conectado desde",
	securityLoggedOutSince: "Último cierre de sesión",
	securityMediaPrefix: "Medios",
	securityMediaTitle: "Medios de seguridad",
	securityMiddleClick: "clic central",
	securityModuleErrorTitle: "Error del módulo de seguridad",
	securityName: "Nombre",
	securityNearbyScreenshots: "Capturas cercanas",
	securityNever: "Nunca",
	securityNewMediaBadge: "nuevo",
	securityNewPolicy: "Nueva política",
	securityNoActivityEvents: "Sin eventos de actividad",
	securityNoAlertRecordingsPage: "Sin grabaciones de alerta en esta página",
	securityNoAlertsForDevice: "Sin alertas para este dispositivo",
	securityNoAlertsFound: "Sin alertas",
	securityNoDevicesFound: "Sin dispositivos",
	securityNoEventsMatchFilter: "Ningún evento coincide",
	securityNoOpenAlerts: "Sin alertas abiertas",
	securityNoPoliciesConfigured: "Sin políticas. Cree una para empezar a supervisar.",
	securityNoPreview: "Sin vista previa",
	securityNoRiskyDevices: "Sin dispositivos riesgosos",
	securityNoScreenshotsFound: "Sin capturas",
	securityNoScreenshotsYet: "Aún no hay capturas",
	securityNoSessionsFound: "Sin sesiones",
	securityNoSessionsRecorded: "Sin sesiones registradas",
	securityNoUserSession: "Sin sesión",
	securityNoUserSessionLiveHint:
		"El PC está encendido pero sin usuario activo. Vista en vivo y capturas no disponibles.",
	securityNoUserSessionTitle: "Ningún usuario conectado",
	securityNoVideoSegmentsFound: "Sin segmentos de vídeo",
	securityNoVideosYet: "Aún no hay segmentos de vídeo",
	securityOS: "SO",
	securityOnlineDevices: "Dispositivos en línea",
	securityOpenAlerts: "Alertas abiertas",
	securityOpenPcRecord: "Abrir registro de PC",
	securityOverrideOff: "OFF",
	securityOverrideOn: "ON",
	securityOverridePrefix: "Anulación:",
	securityOverviewTitle: "Resumen de seguridad",
	securityPageOf: "pág.",
	securityPolActivityTrackingDivider: "Seguimiento de actividad",
	securityPolAfterHoursStart: "Inicio fuera de horario",
	securityPolAlertClipLength: "Duración del clip de alerta (s)",
	securityPolAlertScore: "Puntuación de alerta (0–100)",
	securityPolAlertSeverity: "Gravedad de la alerta",
	securityPolAlertVideoDivider: "Grabación de vídeo de alerta",
	securityPolAlertVideoInfo:
		"Si una regla dispara una alerta, el agente graba un clip de escritorio con la configuración siguiente; igual para todas las reglas.",
	securityPolAllowedHoursDivider: "Horas de captura permitidas",
	securityPolBadgeAlert: "Alerta",
	securityPolBlockedApps: "Aplicaciones bloqueadas",
	securityPolBlockedAppsPh: "p. ej. telegram, discord, torrent",
	securityPolBlockedDomains: "Dominios bloqueados",
	securityPolBlockedDomainsPh: "p. ej. torrent-site.com, telegram.org",
	securityPolBreadcrumbPolicies: "Políticas",
	securityPolBulkThreshold: "Umbral de eventos masivos de archivos (eventos/lote)",
	securityPolBulkThresholdDesc: "Número de eventos destructivos de archivos por lote para disparar",
	securityPolCollectInputMetrics: "Recopilar métricas de actividad de entrada",
	securityPolCollectInputMetricsDesc: "Solo conteos de ratón/teclado (sin contenido de teclas)",
	securityPolCreateAlert: "Crear alerta",
	securityPolCreateAlertDesc: "Si coincide la regla, alerta de seguridad (vídeo = pestaña Captura)",
	securityPolDescription: "Descripción",
	securityPolEditPolicy: "Editar política",
	securityPolEnableRule: "Activar regla",
	securityPolEventsRetention: "Retención de eventos (días)",
	securityPolEventsRetentionDesc: "Registros de actividad más antiguos se purgarán",
	securityPolExcludedDomains: "Dominios excluidos",
	securityPolExcludedDomainsPh: "p. ej. online-banking.com",
	securityPolExcludedProcesses: "Nombres de proceso excluidos",
	securityPolExcludedProcessesPh: "p. ej. 1Password, Bitwarden",
	securityPolInputActivityCounts: "Solo actividad — conteos ratón/teclado",
	securityPolInputDisabledNoTrack: "Desactivado — sin seguimiento de entrada",
	securityPolInputEventsCount: "Solo eventos — solo conteos de teclas",
	securityPolInputFullDetail: "Detalle completo — teclas y posiciones de clic",
	securityPolInputModeLabel: "Modo de seguimiento de entrada",
	securityPolInputTrackingDivider: "Seguimiento de entrada",
	securityPolMaskSensitive: "Enmascarar ventanas sensibles (gestores de contraseñas, banca)",
	securityPolMaskSensitiveDesc: "Sin capturas para apps/ventanas excluidas",
	securityPolMaxFps: "FPS máx.",
	securityPolMediaRetention: "Retención de medios (días)",
	securityPolMediaRetentionDesc: "Capturas y vídeos más antiguos se eliminarán",
	securityPolNewSecurityPolicy: "Nueva política de seguridad",
	securityPolNotifyUsersDesc:
		"Los usuarios seleccionados recibirán una notificación en la aplicación cuando se active cualquier regla de esta política.",
	securityPolNotifyUsersLabel: "Notificar a administradores al activar la política",
	securityPolNotifyUsersPh: "Buscar usuarios a notificar…",
	securityPolPolicyName: "Nombre de la política",
	securityPolPolicyNamePh: "p. ej. Política del equipo de desarrollo",
	securityPolPriority: "Prioridad",
	securityPolPriorityDesc: "Número mayor = se evalúa primero",
	securityPolRecordVideoOnAlert: "Grabar vídeo en alerta de seguridad",
	securityPolRecordVideoOnAlertDesc: "Si está apagado, hay alertas pero sin vídeo",
	securityPolRuleAfterHoursDesc: "Se dispara si hay actividad fuera del horario definido.",
	securityPolRuleAfterHoursLabel: "Actividad fuera de horario",
	securityPolRuleBlockedAppDesc: "Se dispara si el usuario monitoreado abre una app de la lista.",
	securityPolRuleBlockedAppLabel: "Aplicación bloqueada",
	securityPolRuleBlockedDomainDesc:
		"Se dispara si el usuario monitoreado visita un dominio de la lista.",
	securityPolRuleBlockedDomainLabel: "Dominio bloqueado",
	securityPolRuleBulkFileDesc:
		"Se dispara con muchas eliminaciones/renombres/movimientos de archivos en un lote.",
	securityPolRuleBulkFileLabel: "Operaciones masivas de archivos",
	securityPolRuleUsbDesc: "Se dispara al conectar USB a un dispositivo monitoreado.",
	securityPolRuleUsbLabel: "Almacenamiento USB detectado",
	securityPolRulesIntro:
		"Las reglas definen la infracción y la puntuación. Con «Crear alerta» hay alerta de seguridad; el vídeo sigue la pestaña Captura para todas.",
	securityPolSavePolicy: "Guardar política",
	securityPolScope: "Ámbito",
	securityPolScopeDepartment: "Departamento",
	securityPolScopeDevice: "Dispositivos específicos",
	securityPolScopeGlobal: "Global — aplica a todos los dispositivos",
	securityPolScopeUser: "Usuarios específicos",
	securityPolTabCapture: "Captura",
	securityPolTabPrivacy: "Privacidad y exclusiones",
	securityPolTabRetention: "Retención",
	securityPolTabRules: "Reglas",
	securityPolTrackApps: "Seguir aplicaciones activas",
	securityPolTrackFiles: "Seguir actividad de archivos",
	securityPolTrackWebsites: "Seguir visitas web",
	securityPolTrackingMaster: "Seguimiento activado (interruptor maestro)",
	securityPolTrackingMasterDesc: "Apagado desactiva seguimiento de apps, web, archivos y entrada",
	securityPolVisibleNotice: "Mostrar aviso visible de supervisión a empleados",
	securityPolVisibleNoticeDesc: "Muestra un aviso de que el monitoreo está activo",
	securityPolWorkDayStart: "Inicio del día laboral (fin fuera de horario)",
	securityPolWorkingHours: "Horario laboral (opcional)",
	securityPolWorkingHoursDesc:
		"Solo capturar en esta ventana. Formato HH:MM-HH:MM. Vacío = siempre.",
	securityPolWorkingHoursPh: "09:00-18:00",
	securityPoliciesCaptureHint:
		"Las insignias muestran qué está activado. Para activar o desactivar capturas, vídeo, aplicaciones, web o archivos, abra la política (lápiz) → pestaña Captura.",
	securityPoliciesTitle: "Políticas de seguridad",
	securityPolicyDefaultBadge: "Predeterminado de política",
	securityPriority: "Prioridad",
	securityQueued: "¡En cola!",
	securityRecentOpenAlerts: "Alertas abiertas recientes",
	securityRecentScreenshots: "Capturas recientes",
	securityRecordEverySeconds: "Grabar cada (segundos)",
	securityRecordVideo30s: "Grabar vídeo (30 s)",
	securityRefresh: "Actualizar",
	securityResolution: "Resolución",
	securityResolutionNotePlaceholder: "Nota de resolución (opcional)",
	securityResolve: "Resolver",
	securityRightClick: "clic derecho",
	securityRule: "Regla",
	securityRuleCode_AFTER_HOURS: "Fuera de horario",
	securityRuleCode_BLOCKED_APP: "App bloqueada",
	securityRuleCode_BLOCKED_DOMAIN: "Dominio bloqueado",
	securityRuleCode_BULK_FILE_EVENTS: "Eventos masivos de archivos",
	securityRuleCode_USB_DETECTED: "USB detectado",
	securitySaveSettings: "Guardar ajustes",
	securitySaved: "Guardado",
	securityScope: "Ámbito",
	securityScopeType_department: "Departamento",
	securityScopeType_device: "Dispositivo",
	securityScopeType_global: "Global",
	securityScopeType_user: "Usuario",
	securityScreenshotAlt: "Captura",
	securityScreenshotOptionsBlank: "Opciones de captura (vacío = predeterminado de política)",
	securityScreenshots: "Capturas",
	securityScreenshotsCount: "Capturas",
	securityScreenshotsLabel: "Capturas",
	securityScreenshotsToday: "Capturas de pantalla hoy",
	securitySearch: "Buscar",
	securitySearchDevicesPlaceholder: "Buscar host, ID, usuario...",
	securitySegmentLengthSeconds: "Duración del segmento (s)",
	securitySelectedCount: "seleccionados",
	securitySessionActive: "Activo",
	securitySessionIdle: "Inactivo",
	securitySessionLocked: "Pantalla bloqueada",
	securitySessionLockedCaptureHint: "Pantalla bloqueada — capturas y vista en vivo no disponibles.",
	securitySessionLockedLiveHint:
		"El usuario bloqueó la pantalla. La vista en vivo, las capturas y las grabaciones están desactivadas.",
	securitySessionLockedSince: "Bloqueado desde",
	securitySessionLockedTitle: "La pantalla está bloqueada",
	securitySessionNotFound: "Sesión no encontrada",
	securitySessionTimeline: "Línea de tiempo de la sesión",
	securitySessionWord: "Sesión",
	securitySessionsTitle: "Sesiones",
	securitySettingsDrawerTitle: "Ajustes",
	securitySettingsOverrideHint:
		"Anulan la política solo para este dispositivo. Déjelo para heredar.",
	securitySev_critical: "crítica",
	securitySev_high: "alta",
	securitySev_low: "baja",
	securitySev_medium: "media",
	securitySeverity: "Gravedad",
	securityShowAllVideos: "Mostrar todos los vídeos",
	securitySourceEvents: "Eventos de origen",
	securitySpeedSec: "Velocidad (s):",
	securityStart: "Inicio",
	securityStartLive: "Iniciar en vivo",
	securityStatOf: "de",
	securityStatus: "Estado",
	securityStatus_error: "Error",
	securityStatus_offline: "Sin conexión",
	securityStatus_online: "En línea",
	securityStatus_pending: "Pendiente",
	securityStatus_unknown: "desconocido",
	securityStopLive: "Detener en vivo",
	securityTabActivity: "Actividad",
	securityTabAlerts: "Alertas",
	securityTabLive: "En vivo",
	securityTabScreenshots: "Capturas",
	securityTabSessions: "Sesiones",
	securityTabSettings: "Ajustes",
	securityTabVideos: "Vídeos",
	securityTakeScreenshot: "Capturar pantalla",
	securityTitle: "Título",
	securityTooltipAppTrack: "Seguimiento de apps",
	securityTooltipCaptureMaster: "Activar/desactivar captura de pantalla y medios (maestro)",
	securityTooltipScreenshot: "Activar/desactivar capturas",
	securityTooltipTrackingMaster:
		"Interruptor maestro de seguimiento de apps, web, archivos y entrada",
	securityTooltipWebTrack: "Seguimiento web",
	securityTopRiskyDevices: "Dispositivos más riesgosos",
	securityTracking: "Seguimiento",
	securityTrackingEnabledMaster: "Seguimiento activado (maestro)",
	securityTrackingMasterSwitch: "Seguimiento activado (maestro)",
	securityTrackingOffAlertBody: "Seguimiento desactivado en el dispositivo; anula la política.",
	securityTrackingOffAlertTitle: "Anulación de seguimiento: APAGADO",
	securityTrackingWhenOffDesc: "Apagado desactiva seguimiento de apps, web, archivos y entrada",
	securityUnassigned: "Sin asignar",
	securityUnknown: "Desconocido",
	securityUnknownDevice: "Dispositivo desconocido",
	securityUsePolicyDefault: "Predeterminado de política",
	securityUser: "Usuario",
	securityUserLoggedIn: "Sesión activa",
	securityVideoOffAlertBody:
		"Vídeo desactivado en el dispositivo. No hay grabaciones de alerta aunque la política lo permita.",
	securityVideoOffAlertTitle: "Anulación de vídeo: APAGADO",
	securityVideoOptionsBlank: "Opciones de vídeo (vacío = política)",
	securityVideoPlayAllHint:
		"Reproducir todo desde el clip seleccionado hacia segmentos más antiguos; al terminar la página carga la siguiente.",
	securityVideoRecording: "Grabación de vídeo",
	securityVideoSegments: "Segmentos de vídeo",
	securityVideoSegmentsCount: "Segmentos de vídeo",
	securityViewDetail: "Ver detalle",
	securityWebDomainTracking: "Dominios web",
	securityWebPollSeconds: "Sondeo historial web (s)",
	securityWebTracking: "Web",
	securityWebsiteVisitsToday: "Visitas web hoy",
	securityWhen: "Cuándo",
	selectAlbum: "Seleccionar álbum",
	selectAll: "Seleccionar todo",
	selectArtist: "Seleccionar artista",
	selectBoard: "Seleccionar Board",
	selectCategory: "Seleccionar categoría",
	selectChatPartner: "Seleccionar compañero de chat",
	selectClosedDate: "Seleccionar fecha de cierre",
	selectDate: "Seleccionar fecha",
	selectDays: "Seleccionar días",
	selectDomain: "Seleccionar dominio",
	selectEmployee: "Seleccionar empleado",
	selectFiles: "Seleccionar archivos",
	selectGroup: "Seleccionar grupo",
	selectOpenedDate: "Seleccione la fecha de apertura",
	selectParentDepartment: "Seleccionar departamento padre",
	selectParentUser: "Seleccionar usuario padre",
	selectPeriod: "Seleccionar período",
	selectPlatformToManageAndNavigate: "Seleccione una plataforma para gestionar y navegar",
	selectPlaylist: "Seleccionar lista de reproducción",
	selectProduct: "Seleccionar producto",
	selectSomething: "Selecciona algo",
	selectUsers: "Seleccionar usuarios",
	selectedSteps: "Pasos seleccionados",
	selectedUsers: "Usuarios seleccionados",
	seleteSelected: "Seleccionar seleccionados",
	send: "Enviar",
	sent: "Enviado",
	seoDesc: "Descripción SEO",
	servicesAndPrices: "Servicios y precios",
	setCostOfBuildingPermit: "Establecer el costo del permiso de construcción",
	setDayOff: "Establecer día libre",
	settings: "Configuración",
	shiftSchedule: "Horario de turnos",
	showAllSteps: "Mostrar todos los pasos",
	showHistory: "Mostrar historial",
	showProjectDetails: "Mostrar detalles del proyecto",
	showTableColumnFilters: "Mostrar filtros de columnas",
	showTimeline: "Mostrar cronología",
	showing: "Mostrando",
	shuffle: "Aleatorio",
	shuffleEnabled: "Mezcla habilitada",
	shuffleOverride: "Reglas de planificación",
	shuffleOverrideDesc: "Reglas de planificación",
	shuffleOverrideValue: "Reglas de planificación",
	sickLeave: "Baja por enfermedad",
	sickLeaveDays: "Días de baja por enfermedad",
	signIn: "Iniciar sesión",
	signUp: "Registrarse",
	size: "Tamaño",
	slider: "Deslizador",
	small: "Pequeño",
	smb: "Carpeta del servidor",
	socialAmount: "Importe del pago social",
	socialCardImages: "Imágenes de tarjeta social",
	socialCart: "Tarjeta social",
	socialNetworkLink: "Enlace a la red social",
	socialRate: "Tipo de pago social",
	software: "Software",
	softwareSkills: "Habilidades de software",
	somethingWentWrong: "Algo salió mal",
	somethingWentWrongInCreatingSteps:
		"¡Algo salió mal al crear los pasos! Por favor, inténtalo de nuevo",
	sortBy: "Ordenar por",
	source: "Fuente",
	special: "Especial",
	specialItems: "Artículos especiales",
	speed: "Velocidad",
	starred: "Estrellado",
	starredMessages: "Mensajes destacados",
	start: "Comenzar",
	startCall: "Iniciar llamada",
	startDate: "Fecha de inicio",
	startDateShort: "Fecha de inicio",
	startRecording: "Comenzar a grabar",
	startTime: "Hora de inicio",
	startVideoCall: "Iniciar llamada de video",
	starts: "Comienza",
	state: "Estado",
	states: "Estados",
	status: "Estado",
	visibility: "Visibilidad",
	statusUpdate: "Actualización de estado",
	stayAnonymous: "Permanecer anónimo",
	step: "Paso",
	stepIsNotStartedYet: "El paso aún no ha comenzado",
	stepStatus: "Estado del paso",
	stepStatusChangedByUser: "El estado del paso fue cambiado por el usuario",
	steps: "Pasos",
	stepsLeft: "Pasos restantes",
	stillInOffice: "Aún en la oficina",
	stockAndProductOverview: "Resumen de existencias y productos",
	stop: "Detener",
	stopRecording: "Detener la grabación",
	stopped: "Detenido",
	streamDJ: "DJ de radio",
	streamStatistics: "Estadísticas de transmisión",
	streaming: "Transmisión",
	streamsWithShuffle: "transmisiones con mezcla habilitada",
	street: "Calle",
	subDesc: "Subdescripción",
	submit: "Enviar",
	submittedProjects: "Proyectos enviados",
	subscription: "Suscripción",
	subscriptions: "Suscripciones",
	substation: "Subestación",
	substationNumber: "Número de subestación",
	subtasks: "Tareas secundarias",
	subtasksPlaceholder: "Ingrese cada subtarea en una nueva línea",
	subtitle: "Subtítulo",
	success: "Éxito",
	suffix: "Sufijo",
	sun: "Domingo",
	support: "Soporte",
	supportText: "Para todas las preguntas escriba",
	switch: "Interruptor",
	switchers: "Conmutadores",
	switches: "Impresoras",
	syncedFromGoogleContacts: "Sincronizado desde Google Contactos",
	systemSettings: "Configuración del sistema",
	table: "Tabla",
	tag: "Etiqueta",
	tags: "Etiquetas",
	takeMeHome: "Llevarme a casa",
	taskCreatedSuccessfully: "Tarea creada con éxito",
	taskCreatedSuccessfullyDescription: "Tarea creada con éxito",
	taskDescription: "Descripción de la tarea",
	taskMoved: "Tarea movida",
	taskMovedDescription: "Tarea movida a una nueva categoría",
	taskStatusDistribution: "Distribución del estado de las tareas",
	taskTitle: "Título de la tarea",
	tasksAssigned: "Tareas asignadas",
	taxCode: "Código fiscal",
	taxNote: "Etiqueta",
	taxes: "Impuestos",
	technicalFilesUrl: "URL de archivos técnicos",
	telegram: "Telegrama",
	text: "Texto",
	theConstructionDepPrice: "El precio del departamento de construcción",
	theNumberOfAct: "El número de actos",
	thePriceOfProject: "El precio del proyecto",
	themePickerLabel: "Tema",
	thereIsNoResponsible: "No hay responsable",
	thisMonth: "este mes",
	thu: "Jueves",
	ticket: "Boleto",
	ticketClosed: "Ticket cerrado",
	ticketCreateSaveDisabledHint:
		"Elija dominio, grupo de problemas (si aplica), problema y complete los campos relacionados obligatorios antes de guardar.",
	ticketDashboard: "Panel de billetes",
	ticketDomain: "Dominio",
	ticketHierarchyAddProblem: "Añadir problema",
	ticketHierarchyAddProblemGroup: "Añadir grupo",
	ticketHierarchyAddRelatedList: "Añadir lista relacionada",
	ticketHierarchyAddTicket: "Añadir ticket",
	ticketHierarchyAddTicketDomain: "Añadir dominio",
	ticketHierarchyAddTicketHint: "Abre el alta de ticket con este dominio seleccionado.",
	ticketHierarchyGroupsInDomain: "Grupos de problemas en este dominio",
	ticketHierarchyNoneYet: "Ninguno aún — use el botón de arriba.",
	ticketHierarchyProblemsInGroup: "Problemas en este grupo",
	ticketHierarchyProblemsLinkedToList: "Problemas que usan esta lista",
	ticketSystemOverview: "Resumen del rendimiento y las métricas del sistema de billetes",
	ticketTitle: "Título",
	ticketType: "Tipo",
	ticketTypeDomainsHint:
		"Déjelo vacío para que el tipo esté disponible en todos los dominios. Elija uno o varios dominios para mostrarlo solo ahí.",
	ticketTypeDomainsListAll: "Todos los dominios",
	ticketStatus_sent: "Enviado",
	ticketStatus_in_process: "En proceso",
	ticketStatus_resolved_rejected: "Rechazado",
	ticketStatus_resolved_approved: "Aprobado",
	ticketStatus_moved_next: "Movido al siguiente",
	ticketStatus_moved_prev: "Devuelto al anterior",
	ticketStatus_closed: "Cerrado",
	ticketStatus_not_accepted: "No aceptado",
	ticketAction_start: "Iniciar proceso",
	ticketAction_next: "Siguiente paso",
	ticketAction_prev: "Paso anterior",
	ticketAction_approve: "Aprobar",
	ticketAction_reject: "Rechazar",
	ticketAction_close: "Cerrar billete",
	ticketAction_cancel: "Cancelar ticket",
	ticketAction_comment: "Comentario",
	cancelTicket: "Cancelar ticket",
	ticketCancelReason: "Motivo de cancelación",
	ticketCancelComment: "Comentario adicional",
	ticketCancelCommentPlaceholder: "Añade detalles para quien abrió el ticket si hace falta",
	ticketCancelWarning:
		"Este ticket se marcará como no aceptado y se cerrará. Si el usuario aún necesita ayuda, deberá crear un ticket nuevo.",
	ticketNotAccepted: "Ticket no aceptado",
	ticketStepStatus_pending: "Pendiente",
	ticketStepStatus_active: "Activo",
	ticketStepStatus_completed: "Completado",
	ticketStepStatus_approved: "Aprobado",
	ticketStepStatus_rejected: "Rechazado",
	ticketStepStatus_closed: "Cerrado",
	ticketStepStatus_cancelled: "Cancelado",
	tickets: "Billetes",
	ticketsByDepartment: "Billetes por departamento",
	ticketsByImportance: "Billetes por prioridad",
	ticketsByProblem: "Billetes por tipo de problema",
	ticketsByStatus: "Billetes por estado",
	ticketsOverTime: "Billetes a lo largo del tiempo",
	timAgreement: "Acuerdo TIM",
	timDelays: "Retrasos de TIM",
	timSentProjects: "Proyectos enviados a TIM",
	time: "Hora",
	timeBasedScheduling: "Planificación basada en el tiempo",
	timeOff: "Permiso",
	timeRange: "Rango de tiempo",
	timeToClose: "tiempo para cerrar el billete",
	timeToFirstResponse: "tiempo hasta la primera respuesta",
	timeline: "Cronología",
	timestamp: "Marca de tiempo",
	timezone: "Zona horaria",
	title: "Título",
	to: "A",
	toChat: "Ir al chat",
	toDo: "Por hacer",
	today: "Hoy",
	todaysSales: "Ventas de hoy",
	todo: "Tareas",
	todoBoard: "Tablero",
	todoBoards: "Tableros",
	todoCategories: "Categorías",
	todoCategory: "Categoría",
	todoLabel: "Label",
	todoLabels: "Etiquetas",
	todoTag: "Etiqueta",
	todoTags: "Etiquetas",
	todoTask: "Tarea",
	todoTasks: "Tareas",
	toggles: "Interruptores",
	top: "Mejor",
	topCustomers: "Mejores clientes",
	topProducts: "Mejores productos",
	total: "Total",
	totalActiveTasks: "Total de tareas activas",
	totalArtists: "Total de artistas",
	totalChats: "Total de chats",
	totalClients: "Total de clientes",
	totalCoins: "Total de monedas",
	totalContent: "Contenido total",
	totalCustomers: "Total de clientes",
	totalDeductions: "Total deducciones",
	totalDuration: "Duración total",
	totalGroups: "grupos totales",
	totalHours: "Horas totales",
	missingDays: "Días faltantes",
	missingHours: "Horas faltantes",
	scheduled: "Programado",
	totalHoursWorked: "Total de horas trabajadas",
	totalInTrash: "Total en la papelera",
	totalMessages: "Total de mensajes",
	totalOrders: "Total de pedidos",
	totalOvertime: "Horas extra totales",
	totalPlaylists: "Total de listas de reproducción",
	totalPrice: "Precio total",
	totalProducts: "Total de productos",
	totalRevenue: "Ingresos totales",
	totalTickets: "Total de billetes",
	totalTracks: "Total de pistas",
	totalUses: "Total de usos",
	totalValue: "Valor total",
	track: "Pista",
	trackPlaylist: "Lista de reproducción de pistas",
	tracks: "Pistas",
	tracksByArtist: "Pistas por artista",
	transportAllowance: "Subsidio de transporte",
	trash: "Papelera",
	trashAutoDeleteWarning: "Advertencia de eliminación automática de la papelera",
	trashEmptied: "La papelera ha sido vacía",
	trashedOn: "Eliminado el",
	tryAgain: "Intenta de nuevo",
	tue: "Martes",
	type: "Tipo",
	uncoveredInterval: "Intervalo no cubierto",
	undefined: "Indefinido",
	undo: "Deshacer",
	university: "Universidad",
	universityDegree: "Título universitario",
	universityDepartment: "Departamento universitario",
	unjustifiedAbsence: "Ausencia injustificada",
	unknown: "Desconocido",
	unknownArtist: "Artista desconocido",
	unnamed: "Sin nombre",
	unnamedClient: "Cliente sin nombre",
	unnamedTrack: "Pista sin nombre",
	unpaid: "No retribuido",
	unreadMessages: "Mensajes no leídos",
	unresolvedMissingIntervals: "Intervalos no resueltos — la nómina puede ser imprecisa",
	upcomingBirthdays: "Próximos cumpleaños",
	update: "Actualizar",
	updatedAt: "Actualizado en",
	updates: "Actualizaciones",
	upload: "Subir",
	uploadDate: "Fecha de subida",
	uploading: "Subiendo",
	uploads: "Cargas",
	uptime: "Tiempo de actividad",
	urgent: "Urgente",
	used: "Usado",
	usedCount: "Cantidad utilizada",
	usedVacation: "Vacaciones utilizadas",
	user: "Usuario",
	userArchive: "Archivo de usuario",
	userDashboard: "Panel de control de usuario",
	userDeleted: "Eliminado",
	userEntered: "El usuario ingresó",
	userProfile: "Perfil de usuario",
	userPayrollCalcUsesAttendance:
		"Este cálculo usa el resumen canónico de asistencia y ausencias de {monthKey} y luego aplica las reglas fiscales activas de la configuración de RR. HH.",
	userUpdated: "Actualizado",
	userVisited: "El usuario visitó",
	username: "Nombre de usuario",
	users: "Recursos humanos",
	vacationBalance: "Saldo de vacaciones",
	vacationDaysForPeriod: "Días de vacaciones para el período seleccionado",
	vacationInterval: "Intervalo de vacaciones",
	vacationPay: "Pago de vacaciones",
	value: "Valor",
	version: "Versión",
	viber: "Viber",
	video: "Video",
	view: "Ver",
	viewAll: "Ver todo",
	viewDetails: "Ver detalles",
	viewMore: "Ver más",
	viewProject: "Ver proyecto",
	viewSteps: "Ver pasos",
	viewTrash: "Ver la papelera",
	village: "Pueblo",
	villages: "Lista de pueblos",
	visitation: "Visita",
	visitationDeadline: "Fecha límite de visita",
	visitationDelays: "Retrasos de visita",
	voltage: "Voltaje",
	voltageLevel: "Nivel de voltaje",
	volumes: "Volúmenes",
	voluntaryPensionAmount: "Importe de pensión voluntaria",
	voluntaryPensionRate: "Tipo de pensión voluntaria (%)",
	vsPreviousPeriod: "vs período anterior",
	warning: "Advertencia",
	warrantyDesc: "Descripción de garantía",
	warrantyEnd: "Fin de garantía",
	warrantyProvider: "Proveedor de garantía",
	warrantyStart: "Inicio de garantía",
	watchers: "Observadores",
	weatherAriaYerevanForecast: "Pronóstico del tiempo en Ereván",
	weatherCityYerevan: "Ereván",
	weatherClear: "Despejado",
	weatherCloudy: "Nublado",
	weatherDrizzle: "Llovizna",
	weatherFog: "Niebla",
	weatherForecastUnavailable: "Pronóstico no disponible",
	weatherHeadingYerevan: "Tiempo en Ereván",
	weatherHumidity: "Humedad",
	weatherLoadingShort: "Tiempo",
	weatherNextHours: "Próximas horas",
	weatherPartlyCloudy: "Parcialmente nublado",
	weatherRain: "Lluvia",
	weatherSnow: "Nieve",
	weatherThunderstorm: "Tormenta",
	weatherUnknown: "Pronóstico",
	weatherWind: "Viento",
	weatherWindUnit: "km/h",
	wed: "Miércoles",
	weekly: "Semanal",
	whatToDo: "Qué hacer",
	whatToDoLink: "Qué hacer",
	whatsapp: "WhatsApp",
	withAttachments: "Con adjuntos",
	withCoins: "Con monedas",
	withFavorites: "Con favoritos",
	workDays: "Días laborables",
	workInformation: "Información laboral",
	workTime: "Tiempo de trabajo",
	workedDays: "Días trabajados",
	workedHours: "Horas trabajadas",
	working: "Trabajando",
	workingDays: "Días laborales",
	workingHoursByDay: "Horas de trabajo por día",
	workingMinutes: "Minutos de trabajo",
	workingState: "Estado laboral",
	workingStatus: "Estado laboral",
	write: "Escribir",
	writeUsIfThereAreAnyQuestions: "Escríbanos si tiene alguna pregunta",
	writingContent: "Contenido de la escritura",
	writingNumber: "Número de escritura",
	yes: "Sí",
	yesNextStep: "Sí, vaya al siguiente paso",
	yesPreviousStep: "Sí, regrese al paso anterior",
	youWontBeAbleToRevert: "¡No podrás revertir esto!",
	yourFileHasBeenDeleted: "Tu archivo ha sido eliminado.",
	yourFileHasBeenNotSaved: "Tu archivo no ha sido guardado.",
	yourFileHasBeenSaved: "Tu archivo ha sido guardado.",
	zipCode: "Código postal",
	zipCodes: "Códigos postales",
	vacationIntervalNoDeduction: "Las vacaciones no se descuentan en días no laborables",
	knowledgeDashboardLoadFailed: "No se pudo cargar el panel",
	knowledgeArticlesLoadFailed: "No se pudieron cargar los artículos",
	knowledgeBase: "Base de conocimientos",
	knowledgeCreate: "Crear",
	knowledgeRunAutoDocs: "Ejecutar docs automáticas",
	knowledgeTotalArticles: "Total de artículos",
	knowledgePublished: "Publicado",
	knowledgeDrafts: "Borradores",
	knowledgeAutoGenerated: "Generado automáticamente",
	knowledgeLatestUpdatedArticles: "Últimos artículos actualizados",
	knowledgeArticles: "Artículos",
	knowledgeNewArticle: "Nuevo artículo",
	knowledgeFilterArticles: "Filtrar artículos",
	knowledgeCategories: "Categorías",
	knowledgeParentCategory: "Categoría principal",
	knowledgeIcon: "Icono",
	knowledgeColor: "Color",
	knowledgeSortOrder: "Orden",
	knowledgeCategorySaved: "Categoría guardada",
	knowledgeCategoryDeleted: "Categoría eliminada",
	knowledgeSearch: "Buscar",
	knowledgeSearchArticles: "Buscar artículos",
	knowledgePath: "Ruta",
	knowledgeAutoGeneratedDocs: "Documentos generados automáticamente",
	knowledgeSingleRoute: "Ruta única",
	knowledgeNoScreenshots: "Sin capturas",
	knowledgeGenerateDocumentation: "Generar documentación",
	knowledgeImportGeneratedDocs: "Importar docs generadas",
	knowledgeDocumentationGenerationStarted: "Generación de documentación iniciada",
	knowledgeImported: "Importado",
	knowledgeGeneratedDocsImported: "{count} documentos generados importados",
	knowledgeStarted: "Iniciado",
	knowledgeFinished: "Finalizado",
	knowledgeRun: "Ejecución",
	knowledgeOutput: "Salida",
	knowledgeStatus_draft: "Borrador",
	knowledgeStatus_published: "Publicado",
	knowledgeStatus_archived: "Archivado",
	knowledgeVisibility_public: "Público",
	knowledgeVisibility_private: "Privado",
	knowledgeVisibility_company: "Empresa",
	knowledgeRunStatus_idle: "inactivo",
	knowledgeRunStatus_running: "en ejecución",
	knowledgeRunStatus_completed: "completado",
	knowledgeRunStatus_failed: "fallido",
	meetings: "Reuniones",
	meetingsListSubtitle: "Salas programadas con chat APIT y calendario conectados.",
	meetingsCreateMeeting: "Crear reunión",
	meetingsEditMeeting: "Editar reunión",
	meetingsCreateSubtitle: "Reunión = evento de calendario + grupo de chat + sala de video.",
	meetingsMeetingType: "Tipo de reunión",
	meetingsDate: "Fecha",
	meetingsStartTime: "Hora de inicio",
	meetingsEndTime: "Hora de fin",
	meetingsTimezone: "Zona horaria",
	meetingsVisibility: "Visibilidad",
	meetingsParticipants: "Participantes",
	meetingsGroupsDepartments: "Grupos/departamentos",
	meetingsOptionalGroupIds: "ID de grupos opcionales",
	meetingsLocation: "Ubicación",
	meetingsReminderTime: "Tiempo de recordatorio",
	meetingsMinutesShort: "min",
	meetingsAgenda: "Agenda",
	meetingsAgendaPlaceholder: "Inicio\nRevisión de diseño\nSiguientes pasos",
	meetingsRecordingEnabled: "Grabación activada",
	meetingsAllowJoinBeforeHost: "Permitir unirse antes del anfitrión",
	meetingsMuteUsersOnEntry: "Silenciar usuarios al entrar",
	meetingsAllowScreenSharing: "Permitir compartir pantalla",
	meetingsSaveAsDraft: "Guardar como borrador",
	meetingsSaveMeeting: "Guardar reunión",
	meetingsCreateAndNotifyUsers: "Crear y notificar usuarios",
	meetingsSaved: "Reunión guardada",
	meetingsSaveFailed: "No se pudo guardar la reunión",
	meetingsJoin: "Unirse",
	meetingsOpenChat: "Abrir chat",
	meetingsParticipantsCount: "{count} participantes",
	meetingsType_video: "Video",
	meetingsType_audio: "Audio",
	meetingsType_in_person: "Presencial",
	meetingsType_hybrid: "Híbrida",
	meetingsVisibility_private: "Privada",
	meetingsVisibility_company: "Empresa",
	meetingsVisibility_department: "Departamento",
	meetingsStatus_draft: "Borrador",
	meetingsStatus_scheduled: "Programada",
	meetingsStatus_live: "En vivo",
	meetingsStatus_ended: "Finalizada",
	meetingsStatus_cancelled: "Cancelada",
	teamWorkload: "Carga de trabajo del equipo",
	workloadTasks: "Tareas",
	workloadTickets: "Tickets",
	workloadSteps: "Pasos",
	assignedEmployee: "Empleado asignado",
	boughtDate: "Fecha de compra",
	broken: "Averiado",
	depreciation: "Depreciación",
	deviceStatus: "Estado del dispositivo",
	handoverDocument: "Documento de entrega",
	maintenanceSchedule: "Programa de mantenimiento",
	qrCode: "Código QR",
	repair: "Reparación",
	repairHistory: "Historial de reparaciones",
	replacementDate: "Fecha de reemplazo",
	retired: "Retirado",
	returnDocument: "Documento de devolución",
	warrantyDate: "Fecha de garantía",
	noOpenWorkload: "No hay carga de trabajo abierta",
	attendanceTable: "Tabla de asistencia",
	filteredFrom: "filtrado de",
	weekend: "Fin de semana",
	late: "Tarde",
	lateDeparture: "Salida tardía",
	employees: "empleados",
	exportToExcel: "Exportar a Excel",
	overtime: "Horas extra",
	attendanceNextRefresh: "Próxima actualización",
	refreshAttendanceDevices: "Actualizar datos de los dispositivos de asistencia",
	attendanceSyncSuccess: "Dispositivos de asistencia sincronizados",
	attendanceSyncFailed: "Error al sincronizar los dispositivos de asistencia",
	// User account security / profile
	contactInformation: "Información de contacto",
	accountSecurity: "Seguridad de la cuenta",
	accountStatus: "Estado de la cuenta",
	accountStatusActive: "Activa",
	accountStatusLocked: "Bloqueada",
	mustChangePassword: "Debe cambiar la contraseña",
	lockedAt: "Bloqueada el",
	passwordLastChanged: "Contraseña cambiada por última vez",
	accountSecurityDesc: "Las contraseñas actuales nunca son visibles. Use una contraseña temporal o un enlace de restablecimiento seguro cuando deban cambiar las credenciales.",
	accountSecurityHint: "Use «Restablecer contraseña» cuando necesite una rotación inmediata de credenciales. Use «Enviar enlace de restablecimiento» cuando el usuario deba elegir una nueva contraseña sin que el administrador vea ningún secreto.",
	lockAccount: "Bloquear cuenta",
	unlockAccount: "Desbloquear cuenta",
	forcePasswordChangeAction: "Forzar cambio de contraseña",
	clearForcedPasswordChange: "Quitar cambio forzado de contraseña",
	resetPassword: "Restablecer contraseña",
	sendResetLink: "Enviar enlace de restablecimiento",
	sessionVisibilityRequiresPermission: "La visibilidad de sesiones y dispositivos requiere un permiso adicional.",
	resetPasswordConfirmTitle: "¿Restablecer esta contraseña?",
	resetPasswordConfirmText: "Se generará una contraseña temporal y el usuario deberá cambiarla en el próximo inicio de sesión.",
	temporaryPasswordGenerated: "Contraseña temporal generada",
	temporaryPasswordShareHint: "Compártala solo por un canal seguro.",
	sendResetLinkConfirmTitle: "¿Enviar enlace de restablecimiento?",
	sendResetLinkConfirmText: "Se enviará por correo un enlace seguro de un solo uso a este usuario.",
	passwordResetLinkSent: "Enlace de restablecimiento enviado.",
	lockAccountConfirmTitle: "¿Bloquear esta cuenta?",
	unlockAccountConfirmTitle: "¿Desbloquear esta cuenta?",
	lockAccountConfirmText: "El usuario no podrá iniciar sesión hasta que se desbloquee.",
	unlockAccountConfirmText: "El usuario podrá iniciar sesión de inmediato nuevamente.",
	accountLockedMsg: "Cuenta bloqueada.",
	accountUnlockedMsg: "Cuenta desbloqueada.",
	forcePasswordChangeConfirmTitle: "¿Forzar cambio de contraseña en el próximo inicio de sesión?",
	removeForcedPasswordChangeConfirmTitle: "¿Quitar el cambio forzado de contraseña?",
	forcePasswordChangeConfirmText: "El usuario solo podrá iniciar sesión para completar un cambio de contraseña antes de usar la plataforma.",
	removeForcedPasswordChangeConfirmText: "El usuario podrá seguir iniciando sesión con normalidad.",
	forcedPasswordChangeEnabled: "Cambio forzado de contraseña activado.",
	forcedPasswordChangeRemoved: "Cambio forzado de contraseña eliminado.",
	securityUpdated: "Seguridad actualizada",
	securityActionFailed: "Acción de seguridad fallida",
	knownDevicesAndSessions: "Dispositivos conocidos y sesiones abiertas",
	knownDevicesAndSessionsDesc: "Las ubicaciones son aproximadas y suelen representar un origen IP, ISP, salida VPN o puerta de enlace de oficina, no la posición física exacta del dispositivo.",
	openSessionsBadge: "{count} abiertas",
	revokeOtherSessions: "Revocar otras sesiones",
	registeredDevices: "Dispositivos registrados",
	unknownDevice: "Dispositivo desconocido",
	unknownBrowser: "Navegador desconocido",
	unknownOs: "SO desconocido",
	browserOnOs: "{browser} en {os}",
	firstSeen: "Visto por primera vez",
	sessionsBadge: "{count} sesiones",
	currentDevice: "Dispositivo actual",
	noKnownDevices: "Aún no hay dispositivos conocidos registrados.",
	approximateLoginOrigins: "Orígenes de inicio de sesión aproximados",
	sessionDetails: "Detalles de la sesión",
	device: "Dispositivo",
	network: "Red",
	lastActive: "Última actividad",
	approximateLocationUnavailable: "Ubicación aproximada no disponible",
	revoke: "Revocar",
	noAuthSessions: "Aún no hay sesiones de autenticación registradas.",
	sessionOriginApproximateNote: "Los datos de origen de la sesión son aproximados. No trate la geolocalización IP como la posición exacta del dispositivo.",
	connectedMeansNote: "«Conectado» significa que el navegador/app aún tiene un socket activo. «Desconectado» significa que el navegador se cerró o quedó sin conexión, pero la sesión guardada puede seguir válida hasta cerrar sesión, revocar o caducar.",
	revokeThisSessionTitle: "¿Revocar esta sesión?",
	revokeThisSessionText: "El dispositivo/sesión seleccionado deberá iniciar sesión de nuevo.",
	revokeSession: "Revocar sesión",
	sessionRevoked: "Sesión revocada",
	sessionRevokedSuccess: "La sesión seleccionada se revocó correctamente.",
	failedToRevokeSession: "Error al revocar la sesión",
	unableToRevokeSession: "No se pudo revocar la sesión seleccionada.",
	revokeOtherSessionsTitle: "¿Revocar otras sesiones?",
	revokeOtherSessionsText: "Se revocarán todas las sesiones de este usuario excepto la actual cuando el usuario revoca sus propios dispositivos.",
	revokeSessions: "Revocar sesiones",
	sessionsRevoked: "Sesiones revocadas",
	revokedSessionsCount: "Se revocaron {count} sesiones.",
	failedToRevokeSessions: "Error al revocar sesiones",
	unableToRevokeSessions: "No se pudieron revocar las sesiones seleccionadas.",
	failedToLoadSessions: "Error al cargar sesiones",
	unableToLoadUserSessions: "No se pudieron cargar las sesiones del usuario.",
	sessionStatusRevoked: "Revocada",
	sessionStatusConnected: "Conectado",
	sessionStatusDisconnected: "Desconectado",
	currentSession: "Actual",
	passwordChangeOnly: "Solo cambio de contraseña",
	faceId: "Face ID",
	passwordsNeverShownHint: "Las contraseñas nunca se muestran aquí. Use la pestaña Seguridad para bloquear o desbloquear esta cuenta, forzar un cambio de contraseña, generar una contraseña temporal o enviar un enlace de restablecimiento.",
	sharedFolders: "Carpetas compartidas",
	flexId: "Flex Id",
	emailNotProvided: "Correo no proporcionado",
	anonymousUser: "Usuario anónimo",
	noMapPointsYet: "Aún no hay puntos en el mapa",
	noMapPointsYetDesc: "Aún no hay ubicaciones de sesión con coordenadas aproximadas. El backend puede seguir rastreando dispositivos y sesiones sin proveedor geo.",
	googleMapsKeyNotConfigured: "Clave de Google Maps no configurada",
	googleMapsKeyNotConfiguredDesc: "Configure REACT_APP_GOOGLE_MAPS_API_KEY para mostrar el mapa aproximado de sesiones.",
	mapFailedToLoad: "Error al cargar el mapa",
	mapFailedToLoadDesc: "No se puede cargar Google Maps en este momento.",
	approximateLocation: "Ubicación aproximada",
	attendanceLastRefreshed: "Última actualización",
	quarter: "Trimestre",
	year: "Año",
	currentQuarter: "Trimestre actual",
	currentYear: "Año actual",
	chatClearHistory: "Borrar historial",
	chatClearHistoryConfirm: "¿Borrar el historial de este chat solo para ti?",
	chatDeleteForMe: "Eliminar chat",
	chatDeleteForMeConfirm: "¿Eliminar este chat solo para ti? Tu historial visible se borrará y el chat desaparecerá de tu barra lateral.",
	chatBlockUser: "Bloquear usuario",
	chatUnblockUser: "Desbloquear usuario",
	chatBlockedSection: "Contactos bloqueados",
	chatBlockUserConfirm: "¿Bloquear a este usuario? No podrá enviarte mensajes en este chat.",
};
